import { useState, useEffect, useCallback, memo, useRef, useMemo } from 'react';
import { 
  Box,
  Typography,
  Button,
  Stack,
  styled,
  useTheme,
  Paper,
  CircularProgress,
  AppBar,
  Toolbar,
  BottomNavigation,
  BottomNavigationAction,
  useMediaQuery,
  Grid,
  Modal,
  Chip,
  Tooltip,
  IconButton,
  LinearProgress,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Container 
} from '@mui/material';
import { 
  CheckCircleRounded,
  AccountBalanceWallet,
  Task,
  CardGiftcard,
  Apps,
  Collections,
  Menu as MenuIcon
} from '@mui/icons-material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import HomeIcon from '@mui/icons-material/Home';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { motion, AnimatePresence } from 'framer-motion';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TwitterIcon from '@mui/icons-material/Twitter';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { keyframes } from '@emotion/react';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { customersUpdate, customerschildren,nftUpdate,nftNumber,getHomeSections } from './api/auth';

import contractAbi from './contractAbi';
import contractNftAbi from './contractNftAbi';
import learnContractAbi from './contractLearnAbi';
import { 
  useAccount, 
  useConnect, 
  useDisconnect, 
  useChainId,
  useSwitchChain,
  useWriteContract,
  useReadContract,
  useConfig
} from 'wagmi';
import { base } from 'viem/chains';
import { 
  createConfig,
  http,
  cookieStorage,
  createStorage
} from 'wagmi';

import { 
  injected,
  walletConnect,
  coinbaseWallet
} from 'wagmi/connectors';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { isAddress } from 'viem';

import { InjectedConnector } from '@web3-react/injected-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { WalletLinkConnector } from '@web3-react/walletlink-connector';
import imageNFT from './myImage.png';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';

import img1 from './1.png';
import img2 from './2.png';
import img3 from './3.png';
import img4 from './4.png';
import img5 from './5.png';
import img6 from './6.png';
import img7 from './7.png';
import img8 from './8.png';
import img9 from './9.png';
import img10 from './10.png';
import img11 from './11.png';
import img12 from './12.png';
import img13 from './13.png';
import img14 from './14.png';
import img15 from './15.png';
import img16 from './16.png';
import img17 from './17.png';
import img18 from './18.png';

const STEP_IMAGES = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9,
  img10, img11, img12, img13, img14, img15, img16, img17, img18
];


const GOLDOne = '#FFD700';
const GOLD = '#030ef9';
const GOLDDark ='#070b68';
const BLACK = 'rgb(22 22 22)';
const DARK_GREY = '#1A1A1A';
const GREEN = '#4CAF50';
const BLUE = '#2196F3';
const RED = '#F44336';

const baseTheme = createTheme();


const customTheme = createTheme({
  typography: {
    fontFamily: '"Inter", "Manrope", "Urbanist", sans-serif',
    
    h1: {
      fontFamily: '"Sora", "Space Grotesk", "Poppins", sans-serif',
      fontWeight: 800,
      fontSize: '2.5rem',
      lineHeight: 1.1,
      [baseTheme.breakpoints.up('sm')]: {
        fontSize: '3rem',
      },
      [baseTheme.breakpoints.up('md')]: {
        fontSize: '3.5rem',
      },
    },
    h2: {
      fontFamily: '"Sora", "Space Grotesk", "Montserrat", sans-serif',
      fontWeight: 700,
      fontSize: '2rem',
      lineHeight: 1.2,
      [baseTheme.breakpoints.up('sm')]: {
        fontSize: '2.4rem',
      },
      [baseTheme.breakpoints.up('md')]: {
        fontSize: '2.8rem',
      },
    },
    h3: {
      fontFamily: '"Poppins", "Plus Jakarta Sans", "Sora", sans-serif',
      fontWeight: 700,
      fontSize: '2.2rem',
      lineHeight: 1.3,
    },
    h4: {
      fontFamily: '"Plus Jakarta Sans", "Urbanist", "Rubik", sans-serif',
      fontWeight: 600,
      fontSize: '1.8rem',
      lineHeight: 1.4,
    },
    h5: {
      fontFamily: '"Rubik", "Montserrat", "Inter", sans-serif',
      fontWeight: 600,
      fontSize: '1.4rem',
      lineHeight: 1.4,
    },
    h6: {
      fontFamily: '"Urbanist", "Manrope", "Inter", sans-serif',
      fontWeight: 600,
      fontSize: '1.2rem',
      lineHeight: 1.4,
    },
    body1: {
      fontFamily: '"Inter", "Manrope", "Urbanist", sans-serif',
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: '"Manrope", "Inter", "Urbanist", sans-serif',
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    button: {
      fontFamily: '"Poppins", "Montserrat", "Rubik", sans-serif',
      fontWeight: 600,
      textTransform: 'none',
    },
    caption: {
      fontFamily: '"Manrope", "Inter", "Urbanist", sans-serif',
      fontWeight: 400,
    },
    subtitle1: {
      fontFamily: '"Plus Jakarta Sans", "Rubik", "Inter", sans-serif',
      fontWeight: 500,
    },
    subtitle2: {
      fontFamily: '"Urbanist", "Manrope", "Inter", sans-serif',
      fontWeight: 500,
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: 'h1',
          h2: 'h2',
          h3: 'h3',
          h4: 'h4',
          h5: 'h5',
          h6: 'h6',
          subtitle1: 'p',
          subtitle2: 'p',
          body1: 'p',
          body2: 'p',
        },
      },
    },
  },
});
const AnimatedTitle = styled(Typography)({
  fontFamily: '"Sora", "Space Grotesk", "Poppins", sans-serif',
  fontWeight: 900,
  background: `linear-gradient(45deg, ${GOLD} 20%, #FFA500 40%, ${GOLD} 60%, #FFA500 80%)`,
  backgroundSize: '200% auto',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  animation: `${keyframes`
    0% { background-position: 0% center; }
    100% { background-position: 200% center; }
  `} 3s linear infinite`,
  textShadow: '0 8px 32px rgba(255, 215, 0, 0.4)',
  letterSpacing: '1px',
});
const DataDisplayText = styled(Typography)({
  fontFamily: '"Space Grotesk", "Montserrat", "Poppins", sans-serif',
  fontWeight: 700,
});
const StyledButton = styled(Button)({
  fontFamily: '"Poppins", "Montserrat", "Rubik", sans-serif',
  fontWeight: 600,
});
const CardTitle = styled(Typography)({
  fontFamily: '"Plus Jakarta Sans", "Urbanist", "Rubik", sans-serif',
  fontWeight: 700,
});
const DescriptiveText = styled(Typography)({
  fontFamily: '"Manrope", "Inter", "Urbanist", sans-serif',
  fontWeight: 400,
  lineHeight: 1.6,
});

const POLLING_INTERVAL = 12000;
const RPC_URLS = {
  8453: 'https://mainnet.base.org'
};

export const metaMask = new InjectedConnector({
  supportedChainIds: [8453]
});

export const okxWallet = new WalletConnectConnector({
  rpc: { 8453: RPC_URLS[8453] },
  qrcode: true,
  pollingInterval: POLLING_INTERVAL
});

export const binanceWallet = new InjectedConnector({
  supportedChainIds: [8453]
});

export const rabbyWallet = new InjectedConnector({
  supportedChainIds: [8453]
});

export const tokenPocket = new InjectedConnector({
  supportedChainIds: [8453]
});

export const bitgetWallet = new InjectedConnector({
  supportedChainIds: [8453]
});

export const trustWallet = new InjectedConnector({
  supportedChainIds: [8453]
});

export const imToken = new InjectedConnector({
  supportedChainIds: [8453]
});

export const coinbaseWalletConnector = new WalletLinkConnector({
  url: RPC_URLS[8453],
  appName: 'Fruitsweb3',
  supportedChainIds: [8453]
});

export const coin98Wallet = new InjectedConnector({
  supportedChainIds: [8453]
});

export const walletConnectConnector = new WalletConnectConnector({
  rpc: { 8453: RPC_URLS[8453] },
  qrcode: true,
  pollingInterval: POLLING_INTERVAL
});

export const naboxWallet = new InjectedConnector({
  supportedChainIds: [8453]
});

export const gateWallet = new InjectedConnector({
  supportedChainIds: [8453]
});

export const zerionWallet = new InjectedConnector({
  supportedChainIds: [8453]
});

export const allConnectors = {
  metaMask,
  okxWallet,
  binanceWallet,
  rabbyWallet,
  tokenPocket,
  bitgetWallet,
  trustWallet,
  imToken,
  coinbaseWallet: coinbaseWalletConnector,
  coin98Wallet,
  walletConnect: walletConnectConnector,
  naboxWallet,
  gateWallet,
  zerionWallet
};

const projectId = '33ca5fe3b0b78d779d0a1db0a6a398e6';
const metadata = {
  name: 'Fruitsweb3',
  description: 'A Layer2 platform for entertainment and communication with Web 3.',
  url: 'https://fruitsweb3.xyz',
  icons: ['https://fruitsweb3.xyz/logo.ico']
};
const contractAddress = "0x6FE61f4FC540a54d917EA91De609572Fbb17884b";

const contractNftAddress = "0x23279ba8AAA481128Ba97A19e972DC47e81E1e22";
const LEARN_CONTRACT_ADDRESS ="0xB35ffcfe44728cf3DF33395C69EF8adb28343e5e";
const config = createConfig({
  chains: [base],
  storage: createStorage({
    storage: cookieStorage,
  }),
  connectors: [
    injected({
      id: 'metaMask',
      options: {
        name: 'MetaMask',
        shimDisconnect: true,
        getProvider: () => 
          typeof window !== 'undefined' ? window.ethereum : undefined,
      },
    }),
    injected({
      id: 'okxWallet',
      options: {
        name: 'OKX Wallet',
        shimDisconnect: true,
        getProvider: () => {
          if (typeof window !== 'undefined') {
           
            return window.okxwallet || window.okexchain;
          }
          return undefined;
        },
      },
    }),
    injected({
      id: 'binanceWallet',
      options: {
        name: 'Binance Web3 Wallet',
        shimDisconnect: true,
        getProvider: () => 
          typeof window !== 'undefined' ? window.BinanceChain : undefined,
      },
    }),
    injected({
      id: 'rabbyWallet',
      options: {
        name: 'Rabby Wallet',
        shimDisconnect: true,
        getProvider: () => 
          typeof window !== 'undefined' ? window.rabby : undefined,
      },
    }),
    injected({
      id: 'tokenPocket',
      options: {
        name: 'TokenPocket',
        shimDisconnect: true,
        getProvider: () => 
          typeof window !== 'undefined' ? window.tokenpocket : undefined,
      },
    }),
    injected({
      id: 'bitgetWallet',
      options: {
        name: 'Bitget Wallet',
        shimDisconnect: true,
        getProvider: () => 
          typeof window !== 'undefined' ? window.bitkeep : undefined,
      },
    }),
    injected({
      id: 'trustWallet',
      options: {
        name: 'Trust Wallet',
        shimDisconnect: true,
        getProvider: () => 
          typeof window !== 'undefined' ? window.trustwallet : undefined,
      },
    }),
    injected({
      id: 'imToken',
      options: {
        name: 'ImToken',
        shimDisconnect: true,
        getProvider: () => 
          typeof window !== 'undefined' ? window.imToken : undefined,
      },
    }),
    coinbaseWallet({
      id: 'coinbaseWallet',
      appName: 'Fruitsweb3',
    }),
    injected({
      id: 'coin98Wallet',
      options: {
        name: 'Coin98 Wallet',
        shimDisconnect: true,
        getProvider: () => 
          typeof window !== 'undefined' ? window.coin98 : undefined,
      },
    }),
    walletConnect({
      id: 'walletConnect',
      projectId: '33ca5fe3b0b78d779d0a1db0a6a398e6',
      metadata: {
        name: 'Fruitsweb3',
        description: 'A Layer2 platform for entertainment and communication with Web 3.',
        url: 'https://fruitsweb3.xyz',
        icons: ['https://fruitsweb3.xyz/logo.ico']
      }
    }),
    injected({
      id: 'naboxWallet',
      options: {
        name: 'Nabox Wallet',
        shimDisconnect: true,
        getProvider: () => 
          typeof window !== 'undefined' ? window.nabox : undefined,
      },
    }),
    injected({
      id: 'gateWallet',
      options: {
        name: 'Gate Wallet',
        shimDisconnect: true,
        getProvider: () => 
          typeof window !== 'undefined' ? window.gatewallet : undefined,
      },
    }),
    injected({
      id: 'zerionWallet',
      options: {
        name: 'Zerion',
        shimDisconnect: true,
        getProvider: () => 
          typeof window !== 'undefined' ? window.zerionWallet : undefined,
      },
    }),
  ],
  transports: {
    [base.id]: http('https://mainnet.base.org'),
  },
});

const queryClient = new QueryClient();

const secondsToTime = (secs) => {
  const hours = Math.floor(secs / (60 * 60));
  const minutes = Math.floor((secs % (60 * 60)) / 60);
  const seconds = Math.ceil(secs % 60);

  return {
    hours: hours.toString().padStart(2, "0"),
    minutes: minutes.toString().padStart(2, "0"),
    seconds: seconds.toString().padStart(2, "0")
  };
};

const FireworksEffect = () => {
  const particles = Array(100).fill(null);
  const colors = ['#030ef9', '#FF4500', '#FF0000', '#FFFFFF'];
  
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      
      {particles.map((_, i) => {
        const angle = (Math.PI * 2 * i) / particles.length;
        const distance = Math.random() * 500 + 200;
        const duration = Math.random() * 0.8 + 0.5;
        const size = Math.random() * 8 + 4;
        const color = colors[Math.floor(Math.random() * colors.length)];

        return (
          <motion.div
            key={i}
            initial={{
              opacity: 1,
              scale: 1,
              x: 0,
              y: 0,
              rotate: 0,
            }}
            animate={{
              opacity: 0,
              scale: 0,
              x: Math.cos(angle) * distance,
              y: Math.sin(angle) * distance,
              rotate: 360,
            }}
            transition={{
              duration,
              ease: "easeOut",
              delay: 0.1
            }}
            style={{
              position: 'absolute',
              width: size,
              height: size,
              background: color,
              borderRadius: '50%',
              filter: 'blur(2px)',
              boxShadow: `0 0 20px ${color}`,
            }}
          />
        );
      })}

      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          position: 'absolute',
          width: 150,
          height: 150,
          background: 'radial-gradient(circle, #030ef9 0%, transparent 90%)',
          filter: 'blur(40px)',
        }}
      />

      {[...Array(50)].map((_, i) => (
        <motion.div
          key={`secondary-${i}`}
          initial={{
            opacity: 1,
            scale: 1,
            x: 0,
            y: 0,
          }}
          animate={{
            opacity: 0,
            scale: 0.2,
            x: Math.random() * 400 - 200,
            y: Math.random() * 400 - 200,
          }}
          transition={{
            duration: 1.2,
            delay: 0.3
          }}
          style={{
            position: 'absolute',
            width: 20,
            height: 20,
            background: colors[Math.floor(Math.random() * colors.length)],
            borderRadius: '50%',
            filter: 'blur(4px)',
          }}
        />
      ))}
    </Box>
  );
};

const FancyGiftIcon = styled(CardGiftcardIcon)(({ theme }) => ({
  fontSize: '64px',
  color: '#030ef9',
  filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
  '&:hover': {
    transform: 'rotate(-15deg) scale(1.1)',
    transition: 'all 0.3s ease'
  }
}));
const CustomBody = styled(Typography)({
  fontSize: "1.1rem",
  fontFamily: '"Inter", "Manrope", "Urbanist", sans-serif',
  fontWeight: 400,
  lineHeight: 1.7,
});

const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

const GlowCard = styled(motion.div)(({ theme }) => ({
  position: 'relative',
  background: `linear-gradient(135deg, #6aa9df 0%, #ffffff 100%)`,
  borderRadius: '24px',
  padding: '2rem',
  boxShadow: `0 8px 32px rgba(106, 169, 223, 0.3)`,
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    padding: '1rem',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    background: `conic-gradient(
      transparent, 
      rgba(255, 255, 255, 0.3),
      transparent 30%
    )`,
    animation: `${floatAnimation} 3s linear infinite`,
  }
}));

const LearnMintSection = ({ onConnect }) => {
  const { address, isConnected } = useAccount();
  const chainId = useChainId();
  const { switchChain } = useSwitchChain();
  const { writeContract } = useWriteContract();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [cooldownSeconds, setCooldownSeconds] = useState(0);
  const [canMintNow, setCanMintNow] = useState(false);
  const [showFireworks, setShowFireworks] = useState(false);

  const [localCycleCount, setLocalCycleCount] = useState(null);
  
  const { data: mintPrice } = useReadContract({
    address: LEARN_CONTRACT_ADDRESS,
    abi: learnContractAbi,
    functionName: 'MINT_PRICE',
  });
  const { data: cooldown } = useReadContract({
    address: LEARN_CONTRACT_ADDRESS,
    abi: learnContractAbi,
    functionName: 'COOLDOWN',
  });
  const { data: totalImages } = useReadContract({
    address: LEARN_CONTRACT_ADDRESS,
    abi: learnContractAbi,
    functionName: 'TOTAL_IMAGES',
  });

  const { data: cycleCount, refetch: refetchCycleCount } = useReadContract({
    address: LEARN_CONTRACT_ADDRESS,
    abi: learnContractAbi,
    functionName: 'currentCycleCount',
    args: [address],
    query: { enabled: !!address },
  });
  const { data: canMintStatus } = useReadContract({
    address: LEARN_CONTRACT_ADDRESS,
    abi: learnContractAbi,
    functionName: 'canMint',
    args: [address],
    query: { enabled: !!address },
  });
  const { data: remainingCooldownRaw, refetch: refetchRemainingCooldown } = useReadContract({
    address: LEARN_CONTRACT_ADDRESS,
    abi: learnContractAbi,
    functionName: 'remainingCooldown',
    args: [address],
    query: { enabled: !!address },
  });

  useEffect(() => {
    if (canMintStatus !== undefined) {
      setCanMintNow(canMintStatus);
    }
  }, [canMintStatus]);

  useEffect(() => {
    if (remainingCooldownRaw !== undefined) {
      setCooldownSeconds(Number(remainingCooldownRaw));
    }
  }, [remainingCooldownRaw]);

  useEffect(() => {
    if (!canMintNow && cooldownSeconds > 0) {
      const interval = setInterval(() => {
        setCooldownSeconds(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            setCanMintNow(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [canMintNow, cooldownSeconds]);

  const formatTime = (totalSeconds) => {
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${mins.toString().padStart(2,'0')}:${secs.toString().padStart(2,'0')}`;
  };

  const totalSteps = totalImages ? Number(totalImages) : 18;
  const completedSteps = localCycleCount !== null 
  ? localCycleCount 
  : (cycleCount ? Number(cycleCount) : 0);
  const currentImageIndex = completedSteps < totalSteps ? completedSteps : totalSteps - 1;
  const allCompleted = completedSteps >= totalSteps;

  const statusChip = allCompleted
    ? 'Completed'
    : canMintNow
    ? 'Ready'
    : 'Cooldown';
  const chipColor = allCompleted ? GREEN : canMintNow ? GOLD : '#e74c3c';

  const TIMER_COLOR = '#FF69B4';

  const tips = useMemo(() => [
    "🌿 Collect all 18 Health Course NFTs to unlock simple, practical wellness tips!",
    "⏰ Mint a new NFT every 30 minutes and build your healthy lifestyle step by step.",
    "💡 Each NFT features a valuable health lesson to inspire better daily habits.",
  ], []);
  const [activeTip, setActiveTip] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTip(prev => (prev + 1) % tips.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [tips.length]);

  /*const handleMint = async () => {
    if (!isConnected) {
      onConnect();
      return;
    }
    if (chainId !== base.id) {
      try {
        await switchChain({ chainId: base.id });
      } catch (e) {
        toast.error('Please switch to Base network manually');
        return;
      }
    }
    if (!canMintNow || allCompleted) {
      toast.info(allCompleted ? 'All steps completed!' : 'Cooldown not finished yet');
      return;
    }

    setShowFireworks(true);
    setTimeout(() => setShowFireworks(false), 3000);

    writeContract({
      address: LEARN_CONTRACT_ADDRESS,
      abi: learnContractAbi,
      functionName: 'mint',
      value: mintPrice,
      chainId: base.id,
    }, {
      onSuccess: () => {
        toast.success('🎉 Health Tip Minted! +20 Points');
        setCanMintNow(false);
         refetchCycleCount();         
        refetchRemainingCooldown();   
      },
      onError: (error) => {
        console.error(error);
        toast.error(`Mint failed: ${error.shortMessage || error.message}`);
        setShowFireworks(false);
      }
    });
  };*/
  const handleMint = async () => {
  if (!isConnected) {
    onConnect();
    return;
  }
  if (chainId !== base.id) {
    try {
      await switchChain({ chainId: base.id });
    } catch (e) {
      toast.error('Please switch to Base network manually');
      return;
    }
  }
  
  if (!canMintNow) {
    toast.info('Cooldown not finished yet');
    return;
  }

  setShowFireworks(true);
  setTimeout(() => setShowFireworks(false), 3000);

  writeContract({
    address: LEARN_CONTRACT_ADDRESS,
    abi: learnContractAbi,
    functionName: 'mint',
    value: mintPrice,
    chainId: base.id,
  }, {
    onSuccess: () => {
      toast.success('🎉 Health Tip Minted! +20 Points');
      setCanMintNow(false);
      setLocalCycleCount(null);       
      refetchCycleCount();         
      refetchRemainingCooldown();   
    },
    onError: (error) => {
      console.error(error);
      toast.error(`Mint failed: ${error.shortMessage || error.message}`);
      setShowFireworks(false);
    }
  });
};
  const isDataReady = mintPrice !== undefined && cooldown !== undefined && canMintStatus !== undefined;

  return (
    <>
      {showFireworks && <FireworksEffect />}
      <Stack spacing={4} alignItems="center" sx={{ textAlign: 'center', width: '100%' }}>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <AnimatedTitle variant="h3" sx={{ fontSize: { xs: '2rem', md: '2.5rem' } }}>
            🏥 Health Course NFT
          </AnimatedTitle>

          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 700,
              fontSize: { xs: '1rem', md: '1.2rem' },
              letterSpacing: '1px',
              color: '#0052ff',
              textShadow: '0 0 12px #0052ff88',
              mt: 0.8,
              textTransform: 'uppercase',
            }}
          >
            on Base
          </Typography>
        </motion.div>

        <Box
          sx={{
            width: '100%',
            maxWidth: 540,
            p: 2.5,
            background: `linear-gradient(135deg, ${DARK_GREY}cc 0%, ${BLACK}cc 100%)`,
            borderRadius: '20px',
            border: `1px solid ${GOLD}44`,
            backdropFilter: 'blur(10px)',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Box sx={{ minHeight: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTip}
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -15 }}
                transition={{ duration: 0.5, ease: 'easeInOut' }}
                style={{ width: '100%', display: 'flex', alignItems: 'flex-start', gap: 12 }}
              >
               <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    lineHeight: 1.6,
                    fontSize: '0.95rem',
                    background: `linear-gradient(135deg, ${GOLD} 0%, #FFA500 100%)`,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    textShadow: '0 2px 8px rgba(0,82,255,0.3)'
                  }}
                >
                  {tips[activeTip]}
                </Typography>
              </motion.div>
            </AnimatePresence>
          </Box>

          <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 2 }}>
            {tips.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor: index === activeTip ? GOLD : 'rgba(255,255,255,0.3)',
                  transition: 'all 0.3s ease',
                  boxShadow: index === activeTip ? `0 0 8px ${GOLD}` : 'none'
                }}
              />
            ))}
          </Stack>
        </Box>

        <Box sx={{ width: '100%', maxWidth: 540 }}>
          <Stack spacing={5} alignItems="center">
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5 }}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: isMobile ? '100%' : '380px',
                  height: isMobile ? '280px' : '380px',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  boxShadow: `0 10px 30px ${GOLD}40`,
                  border: `4px solid ${GOLD}`,
                  background: '#111',
                  transition: 'all 0.3s ease',
                  '&:hover img': {
                    transform: 'scale(1.03)'
                  }
                }}
              >
                <img
                  src={STEP_IMAGES[currentImageIndex]}
                  alt={`Step ${completedSteps + 1}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    transition: 'transform 0.3s ease'
                  }}
                />
                <Chip
                  label={statusChip}
                  size="small"
                  sx={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    backgroundColor: chipColor,
                    color: 'black',
                    fontWeight: 'bold',
                    fontSize: '0.7rem'
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: 'linear-gradient(to top, rgba(0,0,0,0.9), transparent)',
                    p: 2,
                    textAlign: 'left'
                  }}
                >
                  <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                  >
                    <AnimatedTitle variant="h6" fontWeight="bold">
                      Step {completedSteps + 1} of {totalSteps}
                    </AnimatedTitle>
                  </motion.div>
                  
                  <Typography variant="body2" color="#fff">
                    {allCompleted ? 'All collected!' : `Next: Health Tip #${completedSteps + 1}`}
                  </Typography>
                </Box>
              </Box>
            </motion.div>

            <Box sx={{ width: '100%', px: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>Progress</Typography>
                <Typography variant="body2" color={GOLD} fontWeight="bold">
                  {completedSteps}/{totalSteps}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={(completedSteps / totalSteps) * 100}
                sx={{
                  height: 14,
                  borderRadius: 7,
                  backgroundColor: 'rgba(3, 14, 249, 0.12)',
                  '& .MuiLinearProgress-bar': {
                    background: `linear-gradient(90deg, ${GOLD} 0%, #0052ff 100%)`,
                    borderRadius: 7,
                    boxShadow: `0 0 12px ${GOLD}80`
                  }
                }}
              />
              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block', fontWeight: 500 }}>
                {((completedSteps / totalSteps) * 100).toFixed(1)}% completed
              </Typography>
            </Box>
           
            
            

            <Box sx={{ width: '100%' }}>
              <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.96 }} style={{ width: '100%' }}>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={handleMint}
                  disabled={isConnected && (!canMintNow || allCompleted)}
                  sx={{
                    py: 2.2,
                    borderRadius: '18px',
                    fontSize: '1.25rem',
                    fontWeight: 800,
                    letterSpacing: '0.5px',
                    background: isConnected && canMintNow && !allCompleted
                      ? `linear-gradient(135deg, ${GOLD} 0%, #FFA500 100%)`
                      : isConnected
                        ? '#bdc3c7'
                        : '#0052ff',
                    color: isConnected && canMintNow && !allCompleted ? '#000' : isConnected ? '#7f8c8d' : '#fff',
                    boxShadow: isConnected && canMintNow && !allCompleted
                      ? `0 0 20px ${GOLD}88, 0 8px 20px rgba(0,0,0,0.15)`
                      : 'none',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      background: isConnected && canMintNow && !allCompleted
                        ? `linear-gradient(135deg, #FFA500 0%, ${GOLD} 100%)`
                        : isConnected
                          ? '#bdc3c7'
                          : '#003cad',
                      boxShadow: isConnected && canMintNow && !allCompleted
                        ? `0 0 30px ${GOLD}, 0 12px 25px rgba(0,0,0,0.2)`
                        : 'none',
                    },
                    '&.Mui-disabled': {
                      background: '#ecf0f1',
                      color: '#95a5a6',
                      boxShadow: 'none',
                    },
                  }}
                >
                  {!isConnected
                    ? '🔗 Connect Wallet'
                    : allCompleted
                    ? '✅ All Steps Completed'
                    : canMintNow
                    ? '🌿 Mint Health Tip'
                    : (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600, letterSpacing: '0.3px' }}>
                          ⏳ Cooldown Active
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 800,
                            color: '#0052ff',
                            textShadow: '0 0 8px #0052ff88',
                            fontVariantNumeric: 'tabular-nums',
                            fontSize: '1.1rem',
                          }}
                        >
                          {formatTime(cooldownSeconds)}
                        </Typography>
                      </Box>
                    )
                  }
                </Button>
              </motion.div>
            </Box>
            {allCompleted && canMintNow && (
              <Box sx={{ width: '100%', mb: 2 }}>
                <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.96 }}>
                  <Button
                    fullWidth
                    variant="outlined"
                    size="large"
                    onClick={() => {
                      setLocalCycleCount(0);  
                    }}
                    sx={{
                      py: 2.2,
                      borderRadius: '18px',
                      fontSize: '1.25rem',
                      fontWeight: 800,
                      letterSpacing: '0.5px',
                      border: `2px solid ${GOLD}`,
                      color: GOLD,
                      background: 'transparent',
                      '&:hover': {
                        background: `${GOLD}20`,
                        borderColor: '#FFA500',
                      },
                    }}
                  >
                    Reset
                  </Button>
                </motion.div>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                  Start a new cycle of Health Tips
                </Typography>
              </Box>
            )} 

            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', minHeight: 90 }}>
              {!isConnected ? (
                <Box sx={{ textAlign: 'center', py: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    Connect your wallet to start minting health tips
                  </Typography>
                </Box>
              ) : !isDataReady ? (
                null
              ) : !canMintNow && cooldownSeconds > 0 ? (
                <Box sx={{ textAlign: 'center' }}>
                    <Typography
                        variant="body2"
                        sx={{
                            color: TIMER_COLOR,
                            fontWeight: 600,
                            mb: 2,
                            letterSpacing: '0.3px'
                        }}
                    >
                        Next mint available in:
                    </Typography>

                    <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Box
                            sx={{
                                position: 'absolute',
                                width: 120,
                                height: 120,
                                borderRadius: '50%',
                                background: `radial-gradient(circle, ${TIMER_COLOR}33 0%, transparent 70%)`,
                                filter: 'blur(12px)',
                                zIndex: 0,
                            }}
                        />

                        <CircularProgress
                            variant="determinate"
                            value={
                                cooldown
                                    ? ((Number(cooldown) - cooldownSeconds) / Number(cooldown)) * 100
                                    : 0
                            }
                            size={110}
                            thickness={3}
                            sx={{
                                color: TIMER_COLOR,
                                filter: `drop-shadow(0 0 12px ${TIMER_COLOR})`,
                                zIndex: 1,
                                '& .MuiCircularProgress-circle': {
                                    strokeLinecap: 'round',
                                },
                            }}
                        />

                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 2,
                            }}
                        >
                            <motion.div
                                key={cooldownSeconds}
                                initial={{ scale: 1.2, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.25 }}
                            >
                                <Typography
                                    variant="h5"
                                    fontWeight="bold"
                                    sx={{
                                        color: '#fff',
                                        textShadow: `0 0 15px ${TIMER_COLOR}`,
                                        fontVariantNumeric: 'tabular-nums'
                                    }}
                                >
                                    {formatTime(cooldownSeconds)}
                                </Typography>
                            </motion.div>
                        </Box>
                    </Box>

                    <Box sx={{ mt: 1.5 }}>
                        <motion.div
                            animate={{ opacity: [1, 0.3, 1] }}
                            transition={{ duration: 1.2, repeat: Infinity }}
                            style={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                backgroundColor: TIMER_COLOR,
                                display: 'inline-block',
                                boxShadow: `0 0 10px ${TIMER_COLOR}`
                            }}
                        />
                    </Box>
                </Box>
            ) : canMintNow && !allCompleted ? (
                <Box sx={{ textAlign: 'center' }}>
                  <motion.div
                    animate={{ scale: [1, 1.1, 1] }}
                    transition={{ repeat: Infinity, duration: 1.5 }}
                  >
                    <CheckCircleRounded sx={{ fontSize: 48, color: '#27ae60', mb: 1 }} />
                  </motion.div>
                  <Typography variant="body2" sx={{ color: '#27ae60', fontWeight: 700 }}>
                    Ready to Mint!
                  </Typography>
                </Box>
              ) : allCompleted ? (
                <Box sx={{ textAlign: 'center' }}>
                  <CheckCircleRounded sx={{ fontSize: 48, color: GREEN, mb: 1 }} />
                  <Typography variant="body2" sx={{ color: GREEN, fontWeight: 700 }}>
                    All Health Tips Collected! 🎉
                  </Typography>
                </Box>
              ) : null}
            </Box>
            
          </Stack>
        </Box>
      </Stack>
    </>
  );
};

const Section = ({ section }) => {
  return (
    <Box mb={4} display="flex" flexDirection="column" alignItems="flex-start" 
    
    sx={{
      color: '#fff',
      lineHeight: 1.8,
      fontSize: '1.1rem',
      '& h2, & h3, & h4': {
        color: GOLD,
        marginTop: 4,
        marginBottom: 2,
        fontWeight: 700
      },
      '& p': {
        marginBottom: 3
      },
      '& strong': {
        color: GOLD,
        fontWeight: 600
      },
      '& em': {
        fontStyle: 'italic',
        color: '#ccc'
      }
    }}
    >
      {section.title_sections && (
        <Typography  variant={section.level === "h2" ? "h4":"h5"} component={section.level} gutterBottom>
          {section.title_sections}
        </Typography>
      )}
      {section.content && (
        <CustomBody variant="body1" component="p">
          {section.content}
        </CustomBody>
      )}
      {section.image_url?.url && (
       
        
      
        <Box mt={2}>
          <img 
          src={section.image_url.url}
          alt={section.title_sections || 'Section Image'}
          style={{
            width: '70%',
            height: 'auto',
            display: 'block'
          }}
        />
         
        </Box>
      )}
      {section.sections?.length > 0 && section.sections.map(subSection => (
        <Section key={subSection.id} section={subSection} />
      ))}
    </Box>
  );
};
const BlogDetailSection = ({ blog, onBack, loading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: { xs: 4, sm: 6, md: 8 },
        }}
      >
        <CircularProgress sx={{ color: GOLD }} />
      </Box>
    );
  }

  if (!blog) return null;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'transparent',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
     
      {[...Array(15)].map((_, i) => (
        <motion.div
          key={i}
          style={{
            position: 'absolute',
            width: Math.random() * 6 + 2,
            height: Math.random() * 6 + 2,
            background: GOLD,
            borderRadius: '50%',
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            zIndex: 1,
          }}
          animate={{
            y: [0, -30, 0],
            opacity: [0, 1, 0],
          }}
          transition={{
            duration: Math.random() * 3 + 2,
            repeat: Infinity,
            delay: Math.random() * 2,
          }}
        />
      ))}

    
      <Box 
        sx={{
          background: `linear-gradient(135deg, #6aa9df 0%, #ffffff 100%)`,
          padding: { xs: '80px 16px 40px', sm: '100px 32px 60px', md: '120px 64px 80px' },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <Container maxWidth="lg">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            

            <Typography
              variant="h1"
              sx={{
                fontWeight: 900,
                fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem' },
                background: `linear-gradient(45deg, ${GOLD} 30%, #FFA500 70%)`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                textAlign: 'center',
                mb: 3,
                lineHeight: 1.2
              }}
            >
              {blog.title}
            </Typography>

            
          </motion.div>
        </Container>
      </Box>

  
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} lg={8}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
         
              {blog.main_image_url && (
                <Box
                  sx={{
                    width: '100%',
                    borderRadius: '20px',
                    overflow: 'hidden',
                    mb: 4,
                    boxShadow: `0 20px 60px rgba(0, 0, 0, 0.3)`,
                    border: `2px solid ${GOLD}33`
                  }}
                >
                  <img 
                    src={`https://api.fruitsweb3.xyz/images/${blog.main_image_url}`}
                    alt={blog.title}
                    style={{
                      width: '100%',
                      height: 'auto',
                      display: 'block'
                    }}
                  />
                </Box>
              )}

         
              {blog.summary && (
                <Paper
                  sx={{
                    p: 3,
                    mb: 4,
                    background: `linear-gradient(135deg, ${DARK_GREY} 0%, ${BLACK} 100%)`,
                    border: `1px solid ${GOLD}33`,
                    borderRadius: '16px'
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      color: GOLD,
                      mb: 2,
                      fontWeight: 600
                    }}
                  >
                    Summary
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: '#fff',
                      lineHeight: 1.7,
                      fontSize: '1.1rem'
                    }}
                  >
                    {blog.summary}
                  </Typography>
                </Paper>
              )}

             
              <Box
                sx={{
                  color: '#fff',
                  lineHeight: 1.8,
                  fontSize: '1.1rem',
                  '& h2, & h3, & h4': {
                    color: GOLD,
                    marginTop: 4,
                    marginBottom: 2,
                    fontWeight: 700
                  },
                  '& p': {
                    marginBottom: 3
                  },
                  '& strong': {
                    color: GOLD,
                    fontWeight: 600
                  },
                  '& em': {
                    fontStyle: 'italic',
                    color: '#ccc'
                  }
                }}
                dangerouslySetInnerHTML={{ __html: blog.body }}
              />
              {blog?.sections_all && blog?.sections_all.map(section => (
                <Section key={section.id} section={section} />
                ))}
            
              {blog.tags && blog.tags.length > 0 && (
                <Box sx={{ mt: 4 }}>
                  <Typography variant="h6" sx={{ color: GOLD, mb: 2 }}>
                    Tags
                  </Typography>
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    {blog.tags.map((tag, index) => (
                      <Chip
                        key={index}
                        label={tag.name}
                        sx={{
                          backgroundColor: `${GOLD}15`,
                          color: GOLD,
                          border: `1px solid ${GOLD}33`,
                          mb: 1
                        }}
                      />
                    ))}
                  </Stack>
                </Box>
              )}
            </motion.div>
          </Grid>

          
        </Grid>
      </Container>
    </Box>
  );
};

const HomeSection = ({ section, isFirstSection }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const videoRef = useRef(null);
  const [showUnmuteButton, setShowUnmuteButton] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    if (section.video && videoRef.current) {
      const video = videoRef.current;
      video.muted = true;
      video.autoplay = true;
      
      const playVideo = async () => {
        try {
          await video.play();
          setTimeout(() => {
            setShowUnmuteButton(true);
          }, 2000);
        } catch (error) {
          console.log('Auto-play failed:', error);
          setShowUnmuteButton(true);
        }
      };
      
      playVideo();
    }
  }, [section.video]);

  const handleUnmute = () => {
    if (videoRef.current) {
      videoRef.current.muted = false;
      setShowUnmuteButton(false);
    }
  };


  const isTwoColumnLayout = () => {
    return (section.alignment === 'right' || section.alignment === 'left') && !isMobile;
  };


  const separateContent = () => {
    const mediaItems = [];
    const textItems = [];

    section.content_order.forEach(item => {
      if (item === 'image' || item === 'video') {
        mediaItems.push(item);
      } else if (item === 'title' || item === 'description') {
        textItems.push(item);
      }
    });

    return { mediaItems, textItems };
  };

  const getWidthStyles = () => {
    const width = isMobile ? '100%' : 
                  section.alignment === 'full' ? '100%' : `${section.width_percentage}%`;
    
    const maxWidth = isMobile ? '100%' : 
                     section.alignment === 'full' ? '100%' : '1200px';
  
    return {
      width,
      maxWidth,
      margin: '0 auto'
    };
  };

  const renderMediaContent = (items, isTwoColumn = false) => {
    return items.map((item) => {
      switch (item) {
        case 'image':
          return section.image ? (
            <motion.div
              key="image"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  maxWidth: isTwoColumn ? '500px' : 
                           section.alignment === 'full' ? '100%' : '800px',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: `0 20px 60px rgba(0, 0, 0, 0.3)`,
                  border: `2px solid ${GOLD}33`,
                }}
              >
                <img 
                  src={`https://api.fruitsweb3.xyz/${section.image}`} 
                  alt={section.title || 'Section image'}
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />
              </Box>
            </motion.div>
          ) : null;

        case 'video':
          return section.video ? (
            <motion.div
              key="video"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  maxWidth: isTwoColumn ? '500px' : 
                           section.alignment === 'full' ? '100%' : '800px',
                  height: isTwoColumn ? '300px' : 
                          section.alignment === 'full' ? '500px' : '400px',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  boxShadow: `
                    0 0 80px ${GOLD}40,
                    0 20px 60px rgba(0, 0, 0, 0.8),
                    inset 0 1px 0 rgba(255, 255, 255, 0.2)
                  `,
                  border: `2px solid ${GOLD}33`,
                  background: 'black',
                }}
              >
                <video
                  ref={videoRef}
                  autoPlay
                  loop
                  playsInline
                  muted
                  controls
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                >
                  <source src={`https://api.fruitsweb3.xyz/${section.video}`} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {showUnmuteButton && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      zIndex: 10,
                    }}
                  >
                    <Button
                      variant="contained"
                      startIcon={<VolumeUpIcon />}
                      onClick={handleUnmute}
                      sx={{
                        backgroundColor: 'rgba(0, 82, 255, 0.9)',
                        color: 'white',
                        borderRadius: '25px',
                        px: 3,
                        py: 1,
                        fontWeight: 'bold',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 82, 255, 1)',
                        },
                      }}
                    >
                      Unmute Video
                    </Button>
                  </motion.div>
                )}
              </Box>
            </motion.div>
          ) : null;

        default:
          return null;
      }
    });
  };


  const renderTextContent = (items) => {
    return items.map((item) => {
      switch (item) {
        case 'title':
          return section.title ? (
            <motion.div
              key="title"
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              style={{ width: '100%' }}
            >
              <AnimatedTitle variant="h2" dangerouslySetInnerHTML={{ __html: section.title }} />
            </motion.div>
          ) : null;

        case 'description':
          return section.description ? (
            <motion.div
              key="description"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              style={{ width: '100%' }}
            >
              <Box
                sx={{
                  color: GOLDDark,
                  fontWeight: 300,
                  fontSize: { xs: '1rem', sm: '1.2rem' },
                  letterSpacing: '0.5px',
                  lineHeight: 1.6,
                  '& h1, & h2, & h3, & h4, & h5, & h6': {
                    color: GOLD,
                    marginBottom: 2
                  },
                  '& p': {
                    marginBottom: 2
                  },
                  '& strong, & b': {
                    fontWeight: 700,
                    color: GOLD
                  },
                  '& em, & i': {
                    fontStyle: 'italic'
                  },
                  '& u': {
                    textDecoration: 'underline'
                  }
                }}
                dangerouslySetInnerHTML={{ __html: section.description }}
              />
            </motion.div>
          ) : null;

        default:
          return null;
      }
    });
  };

  const { mediaItems, textItems } = separateContent();

  return (
    <Box
      ref={sectionRef}
      id={`section-${section.id}`}
      sx={{
        minHeight: 'unset',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isFirstSection 
          ? { xs: '66px 16px 16px', sm: '64px 24px 24px', md: '84px 32px 32px' }
          : { xs: 4, sm: 6, md: 8 },
        background: 'transparent',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
    
      {[...Array(15)].map((_, i) => (
        <motion.div
          key={i}
          style={{
            position: 'absolute',
            width: Math.random() * 6 + 2,
            height: Math.random() * 6 + 2,
            background: GOLD,
            borderRadius: '50%',
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            zIndex: 1,
          }}
          animate={{
            y: [0, -30, 0],
            opacity: [0, 1, 0],
          }}
          transition={{
            duration: Math.random() * 3 + 2,
            repeat: Infinity,
            delay: Math.random() * 2,
          }}
        />
      ))}

      <Box sx={{ ...getWidthStyles() }}>
        {isTwoColumnLayout() ? (
         
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 4,
              width: '100%',
            }}
          >
        
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                order: section.alignment === 'right' ? 2 : 1,
              }}
            >
              <Stack spacing={3} sx={{ width: '100%', maxWidth: '500px' }}>
                {renderMediaContent(mediaItems, true)} 
              </Stack>
            </Box>
            
       
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                order: section.alignment === 'right' ? 1 : 2,
              }}
            >
              <Stack 
                spacing={3} 
                sx={{ 
                  width: '100%', 
                  maxWidth: '500px',
                  textAlign: section.alignment === 'right' ? 'right' : 'left'
                }}
              >
                {renderTextContent(textItems)}
              </Stack>
            </Box>
          </Box>
        ) : isMobile && (section.alignment === 'right' || section.alignment === 'left') ? (
         
          <Stack 
            spacing={4} 
            sx={{ 
              position: 'relative', 
              zIndex: 2,
              alignItems: 'center',
              textAlign: 'center'
            }}
          >
            {section.content_order.map((item) => {
              if (item === 'title' || item === 'description') {
                return renderTextContent([item]);
              } else if (item === 'image' || item === 'video') {
                return renderMediaContent([item], false); 
              }
              return null;
            })}
          </Stack>
        ) : (
         
          <Stack 
            spacing={4} 
            sx={{ 
              position: 'relative', 
              zIndex: 2,
              alignItems: section.alignment === 'center' || section.alignment === 'full' ? 'center' : 'flex-start',
              textAlign: section.alignment === 'center' || section.alignment === 'full' ? 'center' : 'left'
            }}
          >
            {section.content_order.map((item) => {
              if (item === 'title' || item === 'description') {
                return renderTextContent([item]);
              } else if (item === 'image' || item === 'video') {
                return renderMediaContent([item], false);
              }
              return null;
            })}
          </Stack>
        )}
      </Box>
    </Box>
  );
};
const BlogSection = ({ onBlogClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  const fetchBlogs = async (page = 1, loadMore = false) => {
    if (loadMore) {
      setLoadingMore(true);
    } else {
      setLoading(true);
    }
    
    try {
      const response = await fetch(`https://api.fruitsweb3.xyz/api/blogs?page=${page}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      
      if (data.status === 'success') {
        if (loadMore) {
          setBlogs(prev => [...prev, ...data.data.posts.data]);
        } else {
          setBlogs(data.data.posts.data);
        }
        setCurrentPage(data.data.posts.current_page);
        setLastPage(data.data.posts.last_page);
      }
    } catch (error) {
      console.error('Error fetching blogs:', error);
      toast.error('Failed to load blogs');
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchBlogs(1);
  }, []);

  const loadMore = () => {
    if (currentPage < lastPage) {
      fetchBlogs(currentPage + 1, true);
    }
  };

  if (loading && blogs.length === 0) {
    return (
      <Box
        sx={{
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: { xs: 4, sm: 6, md: 8 },
        }}
      >
        <CircularProgress sx={{ color: GOLD }} />
      </Box>
    );
  }

  if (blogs.length === 0 && !loading) {
    return null;
  }

  return (
    <Box
      id="section-blogs"
      sx={{
        minHeight: 'unset',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: 4, sm: 6, md: 8 },
        background: 'transparent',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
   
      {[...Array(10)].map((_, i) => (
        <motion.div
          key={i}
          style={{
            position: 'absolute',
            width: Math.random() * 6 + 2,
            height: Math.random() * 6 + 2,
            background: GOLD,
            borderRadius: '50%',
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            zIndex: 1,
          }}
          animate={{
            y: [0, -30, 0],
            opacity: [0, 1, 0],
          }}
          transition={{
            duration: Math.random() * 3 + 2,
            repeat: Infinity,
            delay: Math.random() * 2,
          }}
        />
      ))}
    {/*
      <Box sx={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
        <Stack 
          spacing={4} 
          sx={{ 
            position: 'relative', 
            zIndex: 2,
            alignItems: 'center',
            textAlign: 'center'
          }}
        >
        
          <motion.div
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            style={{ width: '100%' }}
          >
            <AnimatedTitle variant="h2">
              Latest Blogs
            </AnimatedTitle>
            
          </motion.div>

   
          <Grid container spacing={3} justifyContent="center">
            {blogs.map((blog, index) => (
              <Grid item xs={12} sm={6} md={4} key={blog.id}>
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <Paper
                    sx={{
                      borderRadius: '20px',
                      overflow: 'hidden',
                      boxShadow: `0 8px 32px rgba(255, 215, 0, 0.2)`,
                      border: `1px solid ${GOLD}33`,
                      background: `linear-gradient(135deg, ${DARK_GREY} 0%, ${BLACK} 100%)`,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-8px)',
                        boxShadow: `0 16px 48px rgba(255, 215, 0, 0.3)`,
                      }
                    }}
                  >
              
                    {blog.main_image_url && (
                      <Box
                        sx={{
                          width: '100%',
                          height: '200px',
                          overflow: 'hidden',
                          position: 'relative'
                        }}
                      >
                        <img 
                          src={`https://api.fruitsweb3.xyz/images/${blog.main_image_url}`} 
                          alt={blog.title}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                        />
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.7) 100%)',
                          }}
                        />
                      </Box>
                    )}
                    
          
                    <Box sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                      <Typography
                        variant="h6"
                        sx={{
                          color: GOLD,
                          fontWeight: 700,
                          mb: 2,
                          flexGrow: 1,
                          fontSize: '1.1rem',
                          lineHeight: 1.4,
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden'
                        }}
                      >
                        {blog.title}
                      </Typography>
                      
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#aaa',
                          mb: 3,
                          flexGrow: 1,
                          display: '-webkit-box',
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          lineHeight: 1.5
                        }}
                      >
                        {blog.summary || blog.body}
                      </Typography>
                      
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 'auto' }}>
                        <Typography
                          variant="caption"
                          sx={{
                            color: GOLDDark,
                            fontSize: '0.8rem'
                          }}
                        >
                         
                        </Typography>
                        
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => onBlogClick(blog.slug)} 
                          sx={{
                            color: GOLD,
                            borderColor: GOLD,
                            borderRadius: '20px',
                            px: 2,
                            '&:hover': {
                              backgroundColor: `${GOLD}15`,
                              borderColor: GOLD,
                            }
                          }}
                        >
                          Read More
                        </Button>
                      </Box>
                    </Box>
                  </Paper>
                </motion.div>
              </Grid>
            ))}
          </Grid>

  
          {currentPage < lastPage && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Button
                variant="contained"
                onClick={loadMore}
                disabled={loadingMore}
                startIcon={loadingMore ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : null}
                sx={{
                  py: 1.5,
                  px: 4,
                  borderRadius: '25px',
                  fontSize: '1rem',
                  fontWeight: 700,
                  backgroundColor: '#0052ff',
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: '#003cad',
                  },
                  '&.Mui-disabled': {
                    backgroundColor: '#34495e',
                    color: '#666'
                  }
                }}
              >
                {loadingMore ? 'Loading...' : 'Load More'}
              </Button>
            </motion.div>
          )}

      
          {currentPage === lastPage && blogs.length > 0 && (
            <Typography
              variant="body2"
              sx={{
                color: GOLDDark,
                fontStyle: 'italic'
              }}
            >
              
            </Typography>
          )}
        </Stack>
      </Box>
      */}
    </Box>
  );
};

const HomeContent = ({ menuOpen, toggleMenu,activeTab,setActiveTab, blogSlug,setBlogSlug }) => {
  const [sections, setSections] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [blogDetail, setBlogDetail] = useState(null);
  const [loadingBlogDetail, setLoadingBlogDetail] = useState(false); 


  useEffect(() => {
    const fetchHomeSections = async () => {
      try {
        getHomeSections().then(data => {
          const activeSections = data.filter(section => section.is_active);
          setSections(activeSections);
        }).catch(error => {
          console.error("Failed to fetch referrals", error);
        });
      } catch (error) {
        console.error('Error fetching home sections:', error);
      }
    };

    fetchHomeSections();
  }, []);
  useEffect(() => {
    
    if (blogSlug && !selectedBlog && activeTab === 'blog') {
      handleBlogClick(blogSlug);
    }
  }, [blogSlug, activeTab]);
  
  const handleBlogClick = async (blogSlug) => {
    setLoadingBlogDetail(true);
    setSelectedBlog(blogSlug);
    setBlogSlug(blogSlug);
    setActiveTab('blog');
    try {
      const response = await fetch('https://api.fruitsweb3.xyz/api/blogs/one', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ slug: blogSlug })
      });
      const data = await response.json();
      
      if (data.status === 'success') {
        setBlogDetail(data.data.post);
       
        const newUrl = `/blog/${blogSlug}`;
        window.history.pushState({}, '', newUrl);
       
      } else {
        setSelectedBlog(null);
        setBlogSlug(null);
        setActiveTab('home');
      }
    } catch (error) {
      console.error('Error fetching blog detail:', error);
      toast.error('Failed to load blog details');
      setSelectedBlog(null);
      setBlogSlug(null);
    } finally {
      setLoadingBlogDetail(false);
    }
  };

  const handleBackToBlogs = () => {
    setSelectedBlog(null);
    setBlogDetail(null);
    setBlogSlug(null);
 
    setActiveTab('home');
  };

  const scrollToSection = (sectionId) => {
    let element;
    
    if (sectionId === 'blogs') {
  
      element = document.getElementById('section-blogs');
    } else {
   
      element = document.getElementById(`section-${sectionId}`);
    }
    
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start' 
      });
      toggleMenu();
    }
  };
  if(activeTab === 'blog'){
   
    return (
      <Box sx={{ 
        width: '100%',
        minHeight: '100vh',
        background: BLACK,
        position: 'relative',
        pt: 0 
      }}>
         <BlogDetailSection 
            blog={blogDetail}
            onBack={handleBackToBlogs}
            loading={loadingBlogDetail}
          />
      
        
      </Box>
    );
  }
 
  return (
    <Box sx={{ 
      width: '100%',
      minHeight: '100vh',
      background: BLACK,
      position: 'relative',
      pt: 0 
    }}>
      
      <Drawer
        anchor="left"
        open={menuOpen}
        onClose={toggleMenu}
        sx={{
          '& .MuiDrawer-paper': {
            background: `linear-gradient(135deg, ${DARK_GREY} 0%, ${BLACK} 100%)`,
            borderRight: `1px solid ${GOLD}33`,
            width: 280,
            padding: 2
          }
        }}
      >
        <Typography 
          variant="h6" 
          sx={{ 
            color: GOLD, 
            p: 2, 
            textAlign: 'center',
            borderBottom: `1px solid ${GOLD}33`,
            mb: 2
          }}
        >
          Home
        </Typography>
        <List>
          {sections.map((section, index) => (
            <ListItem 
              key={section.id}
              button 
              onClick={() => scrollToSection(section.id)}
              sx={{
                marginBottom: 1,
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: `${GOLD}15`
                }
              }}
            >
              <ListItemText 
                primary={section.section_name}
                primaryTypographyProps={{
                  color: '#fff',
                  fontWeight: 500
                }}
              />
            </ListItem>
          ))}
          
  
          <ListItem 
            button 
            onClick={() => scrollToSection('blogs')}
            sx={{
              marginBottom: 1,
              borderRadius: '8px',
              '&:hover': {
                backgroundColor: `${GOLD}15`
              }
            }}
          >
            <ListItemText 
              primary="Blogs"
              primaryTypographyProps={{
                color: '#fff',
                fontWeight: 500
              }}
            />
          </ListItem>
        </List>
      </Drawer>


      {sections.map((section, index) => (
        <HomeSection key={section.id} section={section} isFirstSection={index === 0} />
      ))}

  
      <BlogSection onBlogClick={handleBlogClick} />

   
      {sections.length === 0 && (
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: BLACK,
            color: 'white',
            textAlign: 'center',
            padding: 4
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};

const DayIndicator = ({ day, checked }) => {
  const theme = useTheme();
  const dayNames = ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5", "Day 6", "Day 7"];
  const numberOne = ["2", "4", "6", "8", "10", "12", "16"];
  return (
    <motion.div 
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: day * 0.1 }}
    >
      <Stack
        alignItems="center"
        spacing={1}
        sx={{
          position: 'relative',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'scale(1.1)'
          }
        }}
      >
        <Paper
          sx={{
            width: { xs: 40, sm: 60 },
            height: { xs: 40, sm: 60 },
            borderRadius: '16px',
            background: checked 
              ? '#0052ff'
              : DARK_GREY,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
            border: `2px solid ${checked ? GOLD : '#333333'}`,
            boxShadow: checked 
              ? `0 4px 20px ${GOLD}33`
              : 'none'
          }}
        >
          <Typography
          variant="caption"
          sx={{
            fontWeight: 700,
            fontSize: '0.85rem',
            color: checked ? "#fff" : GOLDOne,
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}
        >
          {numberOne[day]}
          </Typography>
        </Paper>
        
        <Typography
          variant="caption"
          sx={{
            fontWeight: 700,
            fontSize: '0.85rem',
            color: checked ? '#0052ff' : '#666666',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}
        >
          {dayNames[day]}
        </Typography>
      </Stack>
    </motion.div>
  );
};

const DailyContent = ({ points, daysChecked, handleClaim, account, claim, ConnectWalletString, claimed,connectWallet,timeLeft }) => (
  <>
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2 }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 800,
          background: `linear-gradient(45deg, #f6f5f0 78%, #151515 100%)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          textAlign: 'center',
          fontSize: { xs: '1.8rem', sm: '2.5rem' },
          textShadow: '0 4px 8px rgba(255, 215, 0, 0.3)'
        }}
      >
        Daily Check-In
      </Typography>
      <Typography
        variant="body1"
        sx={{
          textAlign: 'center',
          color: GOLDDark,
          mt: 1,
          fontSize: { xs: '0.8rem', sm: '1rem' }
        }}
      >
        Stay onchain with Base
      </Typography>
    </motion.div>

    <Stack spacing={2} alignItems="center">
      <Box sx={{ 
        position: 'relative', 
        width: { xs: 150, sm: 200 }, 
        height: { xs: 150, sm: 200 } 
      }}>
        <CircularProgress
          variant="determinate"
          value={(daysChecked.filter(Boolean).length / 7) * 100}
          size={{ xs: 150, sm: 200 }}
          thickness={2}
          sx={{
            color: DARK_GREY,
            position: 'absolute'
          }}
        />
        <CircularProgress
          variant="determinate"
          value={(daysChecked.filter(Boolean).length / 7) * 100}
          size={{ xs: 150, sm: 200 }}
          thickness={4}
          sx={{
            color: GOLD,
            position: 'absolute',
            filter: 'drop-shadow(0 4px 12px rgba(255, 215, 0, 0.3))'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center'
          }}
        >
          <DataDisplayText variant="h2" sx={{ color: 'white', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.85)' }}>
            +{points}
          </DataDisplayText>

          <Typography variant="body2" sx={{ color: GOLDDark }}>
            Total REWARD
          </Typography>
        </Box>
      </Box>

      <Stack 
        direction="row" 
        spacing={2} 
        flexWrap="wrap" 
        justifyContent="center"
      >
        {daysChecked.map((checked, index) => (
          <DayIndicator key={index} day={index} checked={checked} />
        ))}
      </Stack>
    </Stack>

    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
       <Button
        fullWidth
        variant="contained"
        size="large"
        onClick={!account ? connectWallet : handleClaim}
        disabled={account && !claim}
        sx={{
          py: 2,
          borderRadius: '14px',
          fontSize: '1.1rem',
          fontWeight: 700,
          backgroundColor: '#0052ff',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#003cad',
          },
          '&.Mui-disabled': {
            backgroundColor: '#34495e',
            color: '#666'
          }
        }}
      >
        <AnimatePresence mode='wait'>
          {claimed ? (
            <motion.span
              key="claimed"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{ color: '#fff' }}
            >
              🎉 Claimed!
            </motion.span>
          ) : (
            <motion.span
              key="claim"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              {!account? ConnectWalletString: !claim ? `Next Claim in: ${timeLeft.hours}:${timeLeft.minutes}:${timeLeft.seconds}` : 'CLAIM'}
            </motion.span>
          )}
        </AnimatePresence>
      </Button>
    </motion.div>
  </>
);


const NftContent = ({ 
  hasNft, 
  handleNft, 
  account, 
  isMinting, 
  nftImage, 
  mintClickCount, 
  totalNfts,
  maxNfts 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [ethStatus, setEthStatus] = useState('stagnant'); 

  useEffect(() => {
    const interval = setInterval(() => {
      const statuses = ['bullish', 'stagnant', 'bearish'];
      const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];
      setEthStatus(randomStatus);
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);

  const getNftBorderColor = () => {
    switch(ethStatus) {
      case 'bullish': return GREEN;
      case 'stagnant': return BLUE;
      case 'bearish': return RED;
      default: return GOLD;
    }
  };

  const getEthStatusText = () => {
    switch(ethStatus) {
      case 'bullish': return 'Positive (> +0.5%)';
      case 'stagnant': return 'Neutral (±0.5%)';
      case 'bearish': return 'Negative (< -0.5%)';
      default: return 'Loading...';
    }
  };

 
  const progressPercentage = maxNfts > 0 ? (totalNfts / maxNfts) * 100 : 0;

  return (
    <Stack spacing={4} sx={{ textAlign: 'center' }}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <AnimatedTitle variant="h3">
          Dynamic NFT on Base
        </AnimatedTitle>
        
        <Typography
          variant="body1"
          sx={{
            color: GOLDDark,
            maxWidth: '600px',
            mx: 'auto',
            mb: 1,
            fontSize: '1.1rem'
          }}
        >
          Hey friends, we are proud to present you with our first Dynamic NFT.
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            color: GOLD,
            maxWidth: '600px',
            mx: 'auto',
            mb: 1,
            fontSize: '1.1rem'
          }}
        >
          To get it, just follow our Twitter page and then Mint it.
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            color: GOLD,
            maxWidth: '600px',
            mx: 'auto',
            mb: 3,
            fontSize: '1.1rem'
          }}
        >
          Our dynamic NFT changes color based on the Ethereum price.
        </Typography>
      </motion.div>

   
     

      <motion.div
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <Box
          sx={{
            position: 'relative',
            width: isMobile ? '100%' : '400px',
            height: isMobile ? '300px' : '400px',
            borderRadius: '20px',
            overflow: 'hidden',
            boxShadow: `0 10px 30px ${getNftBorderColor()}40`,
            border: `4px solid ${getNftBorderColor()}`,
            transition: 'all 0.5s ease',
            '&:hover img': {
              transform: 'scale(1.05)'
            }
          }}
        >
          <img
            src={imageNFT}
            alt="Dynamic NFT"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
              
            }}
          />
          
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              background: 'linear-gradient(to top, rgba(0,0,0,0.9), transparent)',
              p: 2,
              textAlign: 'left'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Typography variant="h6" color={getNftBorderColor()} fontWeight="bold">
                Dynamic NFT
              </Typography>
              <Tooltip title="Color changes based on Ethereum price movement">
                <IconButton size="small" sx={{ ml: 1, color: getNftBorderColor() }}>
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
            <Typography variant="body2" color="#fff">
              Edition: Color-Changing Series
            </Typography>
          </Box>

          <Chip
            label={getEthStatusText()}
            size="small"
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              backgroundColor: getNftBorderColor(),
              color: 'black',
              fontWeight: 'bold',
              fontSize: '0.7rem'
            }}
          />
        </Box>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        <Paper
          sx={{
            p: 3,
            background: '#f8f9fa',
            borderRadius: '16px',
            border: `1px solid ${GOLD}33`,
            boxShadow: `0 8px 32px rgba(255, 215, 0, 0.2)`,
            maxWidth: '600px',
            mx: 'auto'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: GOLD,
              fontWeight: 700,
              mb: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <EmojiEventsIcon sx={{ mr: 1, fontSize: '1.2rem' }} />
            Rare Progress
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="body2" color="#34495e">
              Minted
            </Typography>
            <Typography variant="body2" color={GOLD} fontWeight="bold">
              {totalNfts.toLocaleString()} / {maxNfts.toLocaleString()}
            </Typography>
          </Box>

          <Box sx={{ position: 'relative', width: '100%', height: '12px', bgcolor: GOLD, borderRadius: '6px', overflow: 'hidden', mb: 1 }}>
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: `${progressPercentage}%` }}
              transition={{ duration: 1, ease: "easeOut" }}
              style={{
                height: '100%',
                background: `linear-gradient(90deg, ${GOLDOne} 0%, #FFA500 100%)`,
                borderRadius: '6px',
              }}
            />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="caption" color="#34495e">
              {progressPercentage.toFixed(1)}% minted
            </Typography>
            <Typography variant="caption" color="#34495e">
              {maxNfts - totalNfts} remaining
            </Typography>
          </Box>

          <Chip
            label={`Rarity: ${(totalNfts / maxNfts * 100).toFixed(4)}%`}
            size="small"
            sx={{
              mt: 2,
              background: GOLD,
              color: '#fff',
              border: `1px solid ${GOLD}`
            }}
          />
        </Paper>
      </motion.div>
      <Box sx={{ p: 3, background: '#f8f9fa', borderRadius: '16px', maxWidth: '600px', mx: 'auto' }}>
        <Typography variant="h6" color={GOLD} sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          Color Meaning
          <Tooltip title="Based on 24-hour Ethereum price change">
            <IconButton size="small" sx={{ ml: 1, color: GOLD }}>
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Typography>
        
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1, borderRadius: '8px', bgcolor: 'rgba(76, 175, 80, 0.1)' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: 16, height: 16, borderRadius: '50%', bgcolor: GREEN, mr: 1.5 }} />
              <Typography variant="body2" color="#34495e">Green NFT:</Typography>
            </Box>
            <Typography variant="body2" color={GREEN} fontWeight="bold">
              ETH &gt; +0.5%
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1, borderRadius: '8px', bgcolor: 'rgba(33, 150, 243, 0.1)' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: 16, height: 16, borderRadius: '50%', bgcolor: BLUE, mr: 1.5 }} />
              <Typography variant="body2" color="#34495e">Blue NFT:</Typography>
            </Box>
            <Typography variant="body2" color={BLUE} fontWeight="bold">
              ETH between ±0.5%
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1, borderRadius: '8px', bgcolor: 'rgba(244, 67, 54, 0.1)' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: 16, height: 16, borderRadius: '50%', bgcolor: RED, mr: 1.5 }} />
              <Typography variant="body2" color="#34495e">Red NFT:</Typography>
            </Box>
            <Typography variant="body2" color={RED} fontWeight="bold">
              ETH &lt; -0.5%
            </Typography>
          </Box>
        </Stack>
      </Box>

      <Box sx={{ p: 3, background: '#f8f9fa', borderRadius: '16px', maxWidth: '600px', mx: 'auto' }}>
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" color="#34495e">Network:</Typography>
            <Typography variant="body2" color={GOLD} fontWeight="bold">Base</Typography>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" color="#34495e">Your Balance:</Typography>
            <Typography variant="body2" color={hasNft ? GOLD : '#ff4444'} fontWeight="bold">
              {hasNft ? '1 NFT' : 'No NFTs'}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" color="#34495e">Points Reward:</Typography>
            <Typography variant="body2" color={GOLD} fontWeight="bold">
              200 Points
            </Typography>
          </Box>
        </Stack>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <motion.div
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleNft}
            disabled={hasNft || isMinting}
            startIcon={!hasNft && !isMinting && <TwitterIcon />}
            sx={{
              py: 2,
              borderRadius: '14px',
              fontSize: '1.1rem',
              fontWeight: 700,
              backgroundColor: hasNft ? '#34495e' : '#0052ff',
              color: '#fff',
              '&:hover': {
                backgroundColor: hasNft ? '#34495e' : '#003cad',
              },
              maxWidth: '500px',
            }}
          >
            {isMinting ? (
              <CircularProgress size={24} sx={{ color: '#fff' }} />
            ) : hasNft ? (
              "Already Minted"
            ) : mintClickCount === 1 ? (
              "Mint"
            ) : (
              "Follow & Mint NFT"
            )}
          </Button>
        </motion.div>

        {mintClickCount === 1 && !hasNft && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <Typography variant="body2" color={GOLD} sx={{ fontStyle: 'italic' }}>
              Click again to confirm your mint transaction
            </Typography>
          </motion.div>
        )}
        
        <Typography variant="body2" sx={{ color: '#aaa', mt: 1, display: 'flex', alignItems: 'center' }}>
          Earn 200 points by minting this NFT
          <Tooltip title="Points can be used for future rewards and airdrops">
            <InfoOutlinedIcon sx={{ fontSize: 16, ml: 0.5 }} />
          </Tooltip>
        </Typography>
      </Box>
    </Stack>
  );
};

const ReferralContent = ({ referralLink, referralsList, parentAddress,isNewUser }) => {
  const theme = useTheme();

  return (
    <Stack spacing={4} sx={{ textAlign: 'center' }}>
      <AnimatedTitle variant="h3">
        Referral Program
      </AnimatedTitle>

      {parentAddress !== '0x0000000000000000000000000000000000000000' && (
        <Paper sx={{ p: 2, background: '#f8f9fa',borderRadius: '16px',
        border: `1px solid ${GOLD}33`,
        boxShadow: `0 8px 32px rgba(255, 215, 0, 0.2)` }}>
          <Typography variant="body1" color="#34495e">
            Referred by: {parentAddress}
          </Typography>
        </Paper>
      )}

      <Paper sx={{ p: 3, background: '#f8f9fa',borderRadius: '16px',
        border: `1px solid ${GOLD}33`,
        boxShadow: `0 8px 32px rgba(255, 215, 0, 0.2)` }}>
        { !isNewUser ?  (
        <Stack spacing={2}>
          <Typography variant="h5" color="#34495e">
            Your Referral Link
          </Typography>
          <Box sx={{ p: 2, background: '#0052ff', borderRadius: 2 }}>
            <Typography variant="body2" color='#fff'>
              {referralLink}
            </Typography>
          </Box>
          <Button 
            variant="contained"
            onClick={() => {
              navigator.clipboard.writeText(referralLink);
              toast.success('Copied to clipboard!');
            }}
            sx={{ 
              backgroundColor: '#0052ff',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#003cad',
              }
            }}
          >
            Copy Link
          </Button>
        </Stack>
        ) 
        :
        (
          <Stack spacing={2}>
            <Typography variant="h5" color="#34495e">
              Your Referral Link
            </Typography>
            <Box sx={{ p: 2, background: '#0052ff', borderRadius: 2 }}>
              <Typography variant="body2" color='#fff'>
                {"Access is not allowed."}
              </Typography>
            </Box>
          </Stack>
          )
          }
      </Paper>

      <Paper sx={{ p: 3, background: '#f8f9fa',borderRadius: '16px',
        border: `1px solid ${GOLD}33`,
        boxShadow: `0 8px 32px rgba(255, 215, 0, 0.2)` }}>
        <Typography variant="h5" color="#34495e" gutterBottom>
          Your Referrals ({referralsList.length})
        </Typography>
        <Stack spacing={1} sx={{ maxHeight: 200, overflowY: 'auto' }}>
          {referralsList.length > 0 && referralsList?.map((address, index) => (
            <Typography 
              key={index}
              variant="body2"
              color="#34495e"
              sx={{ 
                p: 1,
                background: '#00000033',
                borderRadius: 1
              }}
            >
              {address}
            </Typography>
          ))}
          {referralsList.length === 0 && (
            <Typography variant="body2" color="#666">
              No referrals yet
            </Typography>
          )}
        </Stack>
      </Paper>
    </Stack>
  );
};

const TasksContent = () => (
  <Stack spacing={4} sx={{ textAlign: 'center' }}>
    <Typography variant="h2" color={BLACK}>
      Coming soon
    </Typography>
  </Stack>
);

const StatCard = memo(({ title, value, icon, index, color, isVisible }) => (
  <motion.div
    initial={{ opacity: 0, y: 50, scale: 0.8 }}
    animate={{ 
      opacity: isVisible ? 1 : 0, 
      y: isVisible ? 0 : 50, 
      scale: isVisible ? 1 : 0.8 
    }}
    transition={{ 
      duration: 0.6, 
      delay: index * 0.15,
      ease: "easeOut"
    }}
    whileHover={{ 
      y: -10,
      scale: 1.03,
      transition: { duration: 0.2 }
    }}
  >
    <Paper 
      sx={{ 
        borderRadius: '16px',
        background: `linear-gradient(135deg, ${DARK_GREY} 0%, ${BLACK} 100%)`,
        p: 3,
        position: 'relative',
        overflow: 'hidden',
        boxShadow: `0 8px 32px rgba(255, 215, 0, 0.2)`,
        border: `1px solid ${GOLD}33`,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: `linear-gradient(90deg, ${color} 0%, ${GOLD} 100%)`,
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              background: `linear-gradient(135deg, ${color}33 0%, ${color}66 100%)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: `2px solid ${color}`,
              boxShadow: `0 4px 20px ${color}40`
            }}
          >
            {icon}
          </Box>
          <Box>
          <CardTitle variant="h6" sx={{ color: '#34495e', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
            {title}
          </CardTitle>
          <DataDisplayText variant="h4" sx={{ 
            color: GOLD, 
            textShadow: '0 2px 10px rgba(255, 215, 0, 0.3)',
            background: `linear-gradient(45deg, ${GOLD} 30%, #FFA500 70%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            {value}
          </DataDisplayText>
          </Box>
        </Box>
        
        <Box 
          sx={{ 
            width: 24, 
            height: 24, 
            borderRadius: '50%',
            background: `radial-gradient(circle, ${color} 0%, ${color}66 100%)`,
            boxShadow: `0 0 20px ${color}80`,
            animation: `${color === '#FF6B6B' ? 'pulse 2s infinite' : ''}`
          }}
        />
      </Box>
      
      <Box 
        sx={{
          position: 'absolute',
          top: -20,
          right: -20,
          width: 80,
          height: 80,
          borderRadius: '50%',
          background: `radial-gradient(circle, ${color}20 0%, transparent 70%)`,
          zIndex: 0
        }}
      />
    </Paper>
  </motion.div>
));

const MoreContent = ({ points, totalDayPoints, totalNftPoints }) => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);
  
  return (
    <Box sx={{ 
      textAlign: 'center', 
      paddingBottom: '80px',
      minHeight: '100vh',
      py: 4,
      px: 2
    }}>
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <AnimatedTitle variant="h3">
          My Statistics
        </AnimatedTitle>
        <Typography 
          variant="body1" 
          sx={{ 
            color: '#aaa', 
            mb: 4,
            maxWidth: '500px',
            mx: 'auto'
          }}
        >
          
        </Typography>
      </motion.div>

      <Stack spacing={3} sx={{ maxWidth: '600px', mx: 'auto' }}>
        <StatCard 
          title="Total Points"
          value={points}
          icon={<EmojiEventsIcon sx={{ color: GOLD, fontSize: 30 }} />}
          index={0}
          color={GOLD}
          isVisible={isVisible}
        />
        
        <StatCard 
          title="Day Points"
          value={totalDayPoints}
          icon={<CardGiftcard sx={{ color: '#4ECDC4', fontSize: 30 }} />}
          index={1}
          color="#4ECDC4"
          isVisible={isVisible}
        />
        
        <StatCard 
          title="NFT Points"
          value={totalNftPoints}
          icon={<Collections sx={{ color: '#FF6B6B', fontSize: 30 }} />}
          index={2}
          color="#FF6B6B"
          isVisible={isVisible}
        />
      </Stack>

      <Box sx={{ position: 'relative', mt: 8 }}>
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 0.3, scale: 1 }}
            transition={{ 
              duration: 1.5, 
              delay: i * 0.3,
              repeat: Infinity,
              repeatType: "reverse"
            }}
            style={{
              position: 'absolute',
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              width: 100,
              height: 100,
              borderRadius: '50%',
              background: `radial-gradient(circle, ${GOLD}10 0%, transparent 70%)`,
              zIndex: 0
            }}
          />
        ))}
      </Box>

      <style>
        {`
          @keyframes pulse {
            0% { opacity: 0.6; transform: scale(1); }
            50% { opacity: 1; transform: scale(1.1); }
            100% { opacity: 0.6; transform: scale(1); }
          }
        `}
      </style>
    </Box>
  );
};

const DesktopMenu = ({ activeTab, handleTabChange, isConnected, address, disconnect, setWalletModalOpen, toggleMenu }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));



  return (
    <AppBar 
      position="fixed" 
      elevation={0}
      sx={{
        background: 'black',
        backdropFilter: 'blur(10px)',
        boxShadow: 'none',
        borderBottom: `1px solid ${GOLD}33`,
        zIndex: 1000
      }}
    >
      <Toolbar>
        <Box sx={{ flexGrow: 1 }} />
        {!isMobile && (
        <Stack 
          direction="row" 
          spacing={2}
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)'
          }}
        >
          <StyledButton
            startIcon={<HomeIcon sx={{ color: '#0052ff' }} />}
            onClick={() => handleTabChange('home')}
            sx={{
              color: activeTab === 'home' ? '#0052ff' : 'white',
              '&:hover': { background: 'rgba(0, 82, 255, 0.1)' }
            }}
          >
            Home
          </StyledButton>

          <StyledButton
            startIcon={<CardGiftcard sx={{ color: '#0052ff' }} />}
            onClick={() => handleTabChange('daily')}
            sx={{
              color: activeTab === 'daily' ? '#0052ff' : 'white',
              '&:hover': { background: 'rgba(0, 82, 255, 0.1)' }
            }}
          >
            Daily
          </StyledButton>

          <StyledButton
            startIcon={<Collections sx={{ color: '#0052ff' }} />}
            onClick={() => handleTabChange('nfts')}
            sx={{
              color: activeTab === 'nfts' ? '#0052ff' : 'white',
              '&:hover': { background: 'rgba(0, 82, 255, 0.1)' }
            }}
          >
            NFT
          </StyledButton>

          <StyledButton
            startIcon={<Task sx={{ color: '#0052ff' }} />}
            onClick={() => handleTabChange('tasks')}
            sx={{
              color: activeTab === 'tasks' ? '#0052ff' : 'white',
              '&:hover': { background: 'rgba(0, 82, 255, 0.1)' }
            }}
          >
            Learn
          </StyledButton>

          <StyledButton
            startIcon={<Apps sx={{ color: '#0052ff' }} />}
            onClick={() => handleTabChange('referral')}
            sx={{
              color: activeTab === 'referral' ? '#0052ff' : 'white',
              '&:hover': { background: 'rgba(0, 82, 255, 0.1)' }
            }}
          >
            Referral
          </StyledButton>

          <StyledButton
            startIcon={<MoreVertIcon sx={{ color: '#0052ff' }} />}
            onClick={() => handleTabChange('more')}
            sx={{
              color: activeTab === 'more' ? '#0052ff' : 'white',
              '&:hover': { background: 'rgba(0, 82, 255, 0.1)' }
            }}
          >
            More
          </StyledButton>

        </Stack>
         )}     
        <Stack direction="row" spacing={1}>
        
          {activeTab === 'home' && (
            <StyledButton
            variant="contained"
            startIcon={<MenuIcon />}
            onClick={toggleMenu}
            sx={{
              backgroundColor: '#0052ff',
              color: '#fff',
              maxWidth: '200px',
              '& .MuiButton-startIcon': {
                marginRight: '6px'
              },
              '&:hover': {
                backgroundColor: '#003cad',
              }
            }}
          >
            Menu
          </StyledButton>
          
            
          )}
          {activeTab !== 'home' && activeTab !== 'home2' && activeTab !== 'blog'  && (
          <StyledButton
            variant="contained"
            startIcon={<AccountBalanceWallet />}
            onClick={() => isConnected ? disconnect() : setWalletModalOpen(true)}
            sx={{
              backgroundColor: '#0052ff',
              color: '#fff',
              maxWidth: '200px',
              '& .MuiButton-startIcon': {
                marginRight: '6px'
              },
              '&:hover': {
                backgroundColor: '#003cad',
              }
            }}
          >
            {!isConnected ? "Connect Wallet" : `${address?.slice(0, 6)}...${address?.slice(-4)}`}
          </StyledButton>
          )}
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

const MobileBottomNav = ({ activeTab, handleTabChange, toggleMenu }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (!isMobile) return null;

  return (
    <BottomNavigation
      value={activeTab}
      onChange={(event, newValue) => handleTabChange(newValue)}
      showLabels
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(0,0,0,0.8)',
        backdropFilter: 'blur(10px)',
        borderTop: `1px solid ${GOLD}33`,
        zIndex: 1000,
        '& .MuiBottomNavigationAction-root': {
          minWidth: '54px',
          maxWidth: '54px',
          padding: '6px 5px',
          color: '#666',
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.6rem',
            color: '#666',
          },
          '& svg': {
            color: '#666',
          }
        },
        '& .Mui-selected': {
          color: '#0052ff',
          '& .MuiBottomNavigationAction-label': {
            color: '#0052ff',
            fontSize: '0.6rem',
          },
          '& svg': {
            color: '#0052ff',
          }
        },
      }}
    >
      <BottomNavigationAction
        label="Home"
        value="home"
        icon={<HomeIcon />}
      />
      <BottomNavigationAction 
        label="Daily" 
        value="daily"
        icon={<CardGiftcard />}
      />
      <BottomNavigationAction 
        label="NFT" 
        value="nfts"
        icon={<Collections />}
      />
      <BottomNavigationAction
        label="Learn"
        value="tasks"
        icon={<Task />}
      />
      <BottomNavigationAction
        label="Referral"
        value="referral"
        icon={<Apps />}
      />
      <BottomNavigationAction
          label="More"
          value="more"
          icon={<MoreHorizIcon />}
          onClick={() => handleTabChange('more')}
        />
    </BottomNavigation>
  );
};

const WalletModal = ({ open, onClose }) => {
  const { connect } = useConnect();
  const { connectors } = useConfig();

const checkProviderExists = (walletId) => {
  if (typeof window === 'undefined') return false;
  
  const providerMap = {
    'io.metamask': () => window.ethereum?.isMetaMask,
    'okxWallet': () => window.okxwallet,
    'binanceWallet': () => window.BinanceChain,
    'rabbyWallet': () => window.rabby,
    'tokenPocket': () => window.tokenpocket,
    'com.bitget.web3': () => window.bitkeep,
    'com.trustwallet.app': () => window.trustwallet,
    'imToken': () => window.imToken,
    'coinbaseWallet': () => window.ethereum?.isCoinbaseWallet,
    'coin98Wallet': () => window.coin98,
    'naboxWallet': () => window.nabox,
    'gateWallet': () => window.gatewallet,
    'zerionWallet': () => window.zerionWallet,
  };
  
  const checkFn = providerMap[walletId];
  return checkFn ? Boolean(checkFn()) : true; 
};
  const wallets = [
    { 
      id: 'io.metamask', 
      name: 'MetaMask', 
      logo: '/images/wallets/metamask.png', 
      connectorId: 'io.metamask'  
    },
    { 
      id: 'okxWallet', 
      name: 'OKX Wallet', 
      logo: '/images/wallets/okx.png', 
      connectorId: 'com.okex.wallet' 
    },
    { 
      id: 'binanceWallet', 
      name: 'Binance Web3 Wallet', 
      logo: '/images/wallets/binance.jpg', 
      connectorId: 'com.binance.wallet' 
    },
    /*{ id: 'io.metamask', name: 'MetaMask', logo: '/images/wallets/metamask.png', connectorId: 'metaMask' },
    { id: 'okxWallet', name: 'OKX Wallet', logo: '/images/wallets/okx.png', connectorId: 'okxWallet' },
    { id: 'binanceWallet', name: 'Binance Web3 Wallet', logo: '/images/wallets/binance.jpg', connectorId: 'binanceWallet' },*/
    { id: 'rabbyWallet', name: 'Rabby Wallet', logo: '/images/wallets/rabby.svg', connectorId: 'rabbyWallet' },
    { id: 'tokenPocket', name: 'TokenPocket', logo: '/images/wallets/tokenpocket.png', connectorId: 'tokenPocket' },
    { 
      id: 'com.trustwallet.app', 
      name: 'Trust Wallet', 
      logo: '/images/wallets/trust.png', 
      connectorId: 'com.trustwallet.app' 
    },
    { 
      id: 'com.bitget.web3', 
      name: 'Bitget Wallet', 
      logo: '/images/wallets/bitget.png', 
      connectorId: 'com.bitget.web3'  
    },
    /*{ id: 'com.bitget.web3', name: 'Bitget Wallet', logo: '/images/wallets/bitget.png', connectorId: 'bitgetWallet' },
    { id: 'com.trustwallet.app', name: 'Trust Wallet', logo: '/images/wallets/trust.png', connectorId: 'trustWallet' },*/
    { id: 'imToken', name: 'ImToken', logo: '/images/wallets/imtoken.png', connectorId: 'imToken' },
    { id: 'coinbaseWallet', name: 'Coinbase Wallet', logo: '/images/wallets/coinbase.png', connectorId: 'coinbaseWalletSDK' },
    { id: 'coin98Wallet', name: 'Coin98 Wallet', logo: '/images/wallets/coin98.png', connectorId: 'coin98Wallet' },
    { id: 'walletConnect', name: 'WalletConnect', logo: '/images/wallets/walletconnect.svg', connectorId: 'walletConnect' },
    { id: 'naboxWallet', name: 'Nabox', logo: '/images/wallets/nabox.png', connectorId: 'com.wallet.nabox' },
    { id: 'gateWallet', name: 'Gate Wallet', logo: '/images/wallets/gate.svg', connectorId: 'gateWallet' },
    { id: 'zerionWallet', name: 'Zerion', logo: 'images/wallets/zerion.png', connectorId: 'zerionWallet' },
  ];

 
  const availableWallets = wallets.filter(wallet => {
   
    if (wallet.id === 'walletConnect') return true;
    
    
    return true;
  });

  const findConnector = (connectors, wallet) => {
   
    let connector = connectors.find(c => c.id === wallet.connectorId);
    
    if (!connector) {
      
      connector = connectors.find(c => c.name === wallet.name);
    }
    
    if (!connector) {
      
      connector = connectors.find(c => 
        c.type === 'injected' && 
        c.name?.toLowerCase().includes(wallet.name.toLowerCase())
      );
    }
    
    return connector;
  };
  
  
  const handleConnect = (wallet) => {
    try {
      const connector = findConnector(connectors, wallet);
      
      if (!connector) {
        console.log('Wallet:', wallet);
        console.log('Available connectors:', connectors.map(c => ({ 
          id: c.id, 
          name: c.name, 
          type: c.type 
        })));
        toast.error(`${wallet.name} connector not found`);
        return;
      }
      
      connect({ connector });
      onClose();
    } catch (error) {
      console.error('Connection error:', error);
      toast.error(`Failed to connect: ${error.message}`);
    }
  };
  
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(4px)',
      }}
    >
      <Paper sx={{ 
        width: { xs: '90%', sm: 600 },
        p: 3, 
        background: `linear-gradient(135deg, ${DARK_GREY} 0%, ${BLACK} 100%)`,
        borderRadius: '16px',
        boxShadow: `0 8px 32px rgba(255, 215, 0, 0.5)`,
        border: `1px solid ${GOLD}`,
        maxHeight: '80vh',
        overflowY: 'auto'
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h5" color={GOLD} textAlign="center" sx={{ fontWeight: 700 }}>
            Connect Wallet
          </Typography>
          <Button onClick={onClose} sx={{ color: GOLD, minWidth: 0 }}>
            ✕
          </Button>
        </Box>
        
        <Typography variant="body2" color="#aaa" textAlign="center" mb={3}>
          By connecting your wallet, you agree to our Terms of Service and Privacy Policy
        </Typography>

        <Grid container spacing={2}>
          {availableWallets.map((wallet) => (
            <Grid item xs={4} sm={3} key={wallet.id}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Button
                  onClick={() => handleConnect(wallet)}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                    p: 2,
                    backgroundColor: '#0052ff',
                    color: '#fff',
                    borderRadius: '12px',
                    '&:hover': {
                      backgroundColor: '#003cad',
                    },
                    '&.Mui-disabled': {
                      backgroundColor: '#444',
                      color: '#666'
                    }
                  }}
                >
                  <Box sx={{ 
                    width: 48, 
                    height: 48,
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <img 
                      src={wallet.logo} 
                      alt={wallet.name} 
                      style={{ 
                        width: '100%', 
                        height: '100%',
                        objectFit: 'contain'
                      }} 
                    />
                  </Box>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 600,
                    textAlign: 'center',
                    fontSize: '0.7rem',
                    lineHeight: 1.2,
                    mt: 0.5,
                    color: '#fff'
                  }}>
                    {wallet.name}
                  </Typography>
                </Button>
              </motion.div>
            </Grid>
          ))}
        </Grid>

      
        {availableWallets.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body1" color={GOLD}>
              No wallets detected. Please install a Web3 wallet.
            </Typography>
            <Button 
              variant="outlined" 
              sx={{ mt: 2, color: GOLD, borderColor: GOLD }}
              onClick={() => window.open('https://ethereum.org/en/wallets/', '_blank')}
            >
              Get a Wallet
            </Button>
          </Box>
        )}
      </Paper>
    </Modal>
  );
};

const SwitchNetworkModal = ({ open, onClose, currentNetwork, targetNetwork }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Paper sx={{ 
        width: { xs: '90%', sm: 500 },
        p: 4, 
        background: `linear-gradient(135deg, ${DARK_GREY} 0%, ${BLACK} 100%)`,
        borderRadius: '20px',
        boxShadow: `0 20px 60px rgba(0, 82, 255, 0.5)`,
        border: `2px solid ${GOLD}`,
        textAlign: 'center',
        overflow: 'hidden',
        position: 'relative'
      }}>
       
        <Box sx={{
          position: 'absolute',
          top: -100,
          right: -100,
          width: 300,
          height: 300,
          borderRadius: '50%',
          background: `radial-gradient(circle, ${GOLD}20 0%, transparent 70%)`,
          zIndex: 0
        }} />
        
        <Box sx={{ position: 'relative', zIndex: 1 }}>
      
          <Box sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: `linear-gradient(135deg, #0052ff 0%, ${GOLD} 100%)`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
            boxShadow: `0 8px 32px rgba(0, 82, 255, 0.4)`,
            border: `2px solid ${GOLD}`
          }}>
            <AccountBalanceWallet sx={{ fontSize: 40, color: '#fff' }} />
          </Box>

      
          <Typography variant="h4" sx={{ 
            color: GOLD, 
            fontWeight: 800,
            mb: 2,
            background: `linear-gradient(45deg, ${GOLD} 30%, #0052ff 70%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            Switch Network Required
          </Typography>

         
          <Typography variant="body1" sx={{ 
            color: '#ccc', 
            mb: 4,
            fontSize: '1.1rem',
            lineHeight: 1.6
          }}>
            Please switch your wallet network to <strong style={{ color: GOLD }}>Base Mainnet </strong> 
             to continue with this transaction.
          </Typography>

         
          

         
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: '12px',
                border: `2px solid ${GOLD}`,
                color: GOLD,
                fontWeight: 600,
                '&:hover': {
                  background: `${GOLD}15`,
                  borderColor: GOLD
                }
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={onClose}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: '12px',
                background: `linear-gradient(135deg, #0052ff 0%, ${GOLD} 100%)`,
                color: '#fff',
                fontWeight: 600,
                '&:hover': {
                  background: `linear-gradient(135deg, #003cad 0%, ${GOLD} 100%)`,
                  boxShadow: `0 8px 32px rgba(0, 82, 255, 0.4)`
                }
              }}
            >
              I'll Switch Now
            </Button>
          </Stack>

         
          <Typography variant="caption" sx={{ 
            color: '#666', 
            mt: 3,
            display: 'block',
            fontStyle: 'italic'
          }}>
            After switching to Base Mainnet, please try the transaction again.
          </Typography>
        </Box>
      </Paper>
    </Modal>
  );
};


const DailyCheckIn = () => {
  const pathToTabMap = {
    '/': 'home',
    '/daily': 'daily', 
    '/nft': 'nfts',
    '/learn': 'tasks',
    '/referral': 'referral',
    '/more': 'more',
    '/blog': 'blog'
  };
  const tabToPathMap = {
    'home': '/',
    'daily': '/daily',
    'nfts': '/nft',
    'tasks': '/learn', 
    'referral': '/referral',
    'more': '/more',
    'blog': '/blog'
  };
  const [activeTab, setActiveTab] = useState(() => {
    const path = window.location.pathname;
    return pathToTabMap[path] || 'daily';
  });
  
  const [totalNfts, setTotalNfts] = useState(0);
  const [maxNfts, setMaxNfts] = useState(100000); 
  const [menuOpen, setMenuOpen] = useState(false);

  const { address, isConnected } = useAccount();
  const { connect } = useConnect();
  const { disconnect } = useDisconnect();
  const chainId = useChainId();
  const { switchChain } = useSwitchChain();
  
  const [walletModalOpen, setWalletModalOpen] = useState(false);
  const [referralLink, setReferralLink] = useState('');
  const [referralsList, setReferralsList] = useState([]);
  const [parentAddress, setParentAddress] = useState('');
  const [points, setPoints] = useState(0);
  const [totalDayPoints, setTotalDayPoints] = useState(0);
  const [totalNftPoints, setTotalNftPoints] = useState(0);
  const [currentStreak, setCurrentStreak] = useState(0);
  const [claim, setClaim] = useState(false);
  const [isNewUser, setIsNewUser] = useState(true);
  const [ConnectWalletString, setConnectWalletString] = useState("Connect Wallet");
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });
  const [daysChecked, setDaysChecked] = useState([false, false, false, false, false, false, false]);
  const [claimed, setClaimed] = useState(false);
  const [referralAddress, setReferralAddress] = useState('0x0000000000000000000000000000000000000000');
  const [blogSlug, setBlogSlug] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const [mintClickCount, setMintClickCount] = useState(0);
  const [hasNft, setHasNft] = useState(false);
  const [nftImage, setNftImage] = useState("https://bafybeihhpvpac4ll2hyuqf2ho6j7xoxwgtt72lqa2f4bp4sfsrcmp2wghy.ipfs.dweb.link?filename=blue.png");
  const [isMinting, setIsMinting] = useState(false);
  const [switchNetworkModal, setSwitchNetworkModal] = useState({
    open: false,
    currentNetwork: '',
    targetNetwork: 'Base Mainnet'
  });

  const { data: nftBalance, refetch: refetchNftBalance } = useReadContract({
    address: contractNftAddress,
    abi: contractNftAbi,
    functionName: 'balanceOf',
    args: [address],
    query: {
      enabled: isConnected && !!address,
    }
  });
  
  const { writeContract: mintNft } = useWriteContract({
    mutation: {
      onSuccess: () => {
        setIsMinting(false);
        setMintClickCount(0);

        setTimeout(() => {
          refetchUserData();
        }, 2000);

        toast.success("NFT Minted Successfully!");
        refetchNftBalance();
      },
      onError: (error) => {
        setIsMinting(false);
        let errorMessage = error?.message || "Unknown error";

      
        if (
          errorMessage.includes("Chain ID")  || 
          errorMessage.includes("chain mismatch") ||
          errorMessage.includes("ChainMismatch") ||
          errorMessage.includes("wrong network")
        ) {
          showSwitchNetworkModal();
         
        } else if (errorMessage.includes("User rejected")) {
          toast.error("Transaction was rejected by the user. Please approve the transaction in your wallet.");
        } else {
          toast.error(`Minting Error: ${errorMessage}`);
        }
      }
    }
  });
  /*
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      const newTab = pathToTabMap[path] || 'daily';
      setActiveTab(newTab);
    };
    
    const fetchTotalNfts = async () => {
      try {
        const response = await nftNumber();
        if (response.status === 'success') {
          setTotalNfts(response.number);
        }
      } catch (error) {
        console.error('Failed to fetch total NFTs:', error);
      }
    };
    
    fetchTotalNfts();
    window.addEventListener('popstate', handlePopState);

    const path = window.location.pathname;
    const initialTab = pathToTabMap[path] || 'daily';
    setActiveTab(initialTab);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);*/
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      
      if (path.startsWith('/blog/')) {
        const slugFromPath = path.replace('/blog/', '');
        if (slugFromPath) {
          setBlogSlug(slugFromPath);
          setActiveTab('blog');
         
          return;
        } else {
          setActiveTab('home');
        }
      }
      
      const newTab = pathToTabMap[path] || 'daily';
      setActiveTab(newTab);
    };
    
    
    const initialPath = window.location.pathname;
    if (initialPath.startsWith('/blog/')) {
      const slugFromPath = initialPath.replace('/blog/', '');
      if (slugFromPath) {
        setBlogSlug(slugFromPath);
        setActiveTab('blog');
      
      }
    } else {
      const initialTab = pathToTabMap[initialPath] || 'daily';
      setActiveTab(initialTab);
    }
  
    window.addEventListener('popstate', handlePopState);
  
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  useEffect(() => {
    if (nftBalance !== undefined) {
      setHasNft(Number(nftBalance) > 0);
    }
  }, [nftBalance]);
  
  useEffect(() => {
    if (activeTab === 'nft') {
      window.location.href = 'https://home.fruitsweb3.xyz';
    }
  }, [activeTab]);
  const showSwitchNetworkModal = (currentNetworkName = 'Base Mainnet') => {
    setSwitchNetworkModal({
      open: true,
      currentNetwork: currentNetworkName,
      targetNetwork: 'Base Mainnet'
    });
  };
  const closeSwitchNetworkModal = () => {
    setSwitchNetworkModal({
      open: false,
      currentNetwork: '',
      targetNetwork: 'Base Mainnet'
    });
  };
  

  const handleNft = async () => {
    if (!isConnected) {
      setWalletModalOpen(true);
      return;
    }
    /*const isOnBaseNetwork = await checkBaseNetwork();
    if (!isOnBaseNetwork) {
      return; 
    }*/
    if (chainId !== base.id) {
      if (switchChain) {
        switchChain({ chainId: base.id });
        toast.info("Switching to Base network...");
        return;
      } else {
        toast.error('Please switch to Base network');
        return;
      }
    }

    if (hasNft) {
      toast.info("You already own this NFT!");
      return;
    }

    if (mintClickCount === 0) {
      window.open('https://x.com/intent/follow?screen_name=fruitsweb3', '_blank');
      setMintClickCount(1);
      toast.info("Please click mint again to confirm");
      return;
    }

    setIsMinting(true);
    mintNft({
      address: contractNftAddress,
      abi: contractNftAbi,
      functionName: 'mint',
      value: 300000000000000n,
      chainId: base.id,
    });
    
    const updateNftCount = async () => {
      try {
        const response = await nftUpdate(address);
        if (response.status === 'success' && response.nft_balance) {
          setTotalNfts(response.nft_balance);
        }
      } catch (error) {
        console.error('Failed to update NFT count:', error);
      }
    };

    updateNftCount();
    navigateToTab('nfts');
  };

  const { data: userData, refetch: refetchUserData } = useReadContract({
    address: contractAddress,
    abi: contractAbi,
    functionName: 'getUserData',
    args: [address],
    query: {
      enabled: isConnected && !!address,
    }
  });
  
  const updateCustomersUpdate = async () => {
    console.log("updateCustomersUpdate");
    try {
      await customersUpdate(address, parentAddress);
    } catch (apiError) {
          console.error("API Error:", apiError);
          
    }
  };
  
  const { writeContract: checkIn } = useWriteContract({
    mutation: {
      onSuccess: () => {
        setClaimed(true);
        
        const nextCheckinTime = Math.floor(Date.now() / 1000) + 86400;
        const currentTime = Math.floor(Date.now() / 1000);
        let remainingTime = nextCheckinTime - currentTime;
        if (remainingTime < 0) remainingTime = 0;
        
        setTimeLeft(secondsToTime(remainingTime));
        setClaim(false);
        setTimeout(() => {
          updateCustomersUpdate();
        }, 4000);
        setTimeout(() => {
          refetchUserData();
          setClaimed(false);
        }, 2000);
        toast.success("Successfully Check-In!");
        setConnectWalletString('CLAIM');
      },
      onError: (error) => {
       
        let errorMessage = error?.message || "Unknown error";

      
      if (
        errorMessage.includes("Chain ID")  || 
        errorMessage.includes("chain mismatch") ||
        errorMessage.includes("ChainMismatch") ||
        errorMessage.includes("wrong network")
      ) {
        showSwitchNetworkModal();
      
      } else if (errorMessage.includes("User rejected")) {
        toast.error("Transaction was rejected by the user. Please approve the transaction in your wallet.");
      } else {
        toast.error(`Error: ${error.message}`);
      }
        setConnectWalletString('CLAIM');
      }
    }
  });

  useEffect(() => {
    if (isConnected && address) {
      setReferralLink(`${window.location.origin}?ref=${address}`);
      
      customerschildren(address).then(data => {
        setReferralsList(data.children || []);
      }).catch(error => {
        console.error("Failed to fetch referrals", error);
      });
    } else {
      setReferralsList([]);
    }
  }, [isConnected, address]);
  useEffect(() => {
     
      switchChain({ chainId: base.id });
    
  },[isConnected, address, chainId, switchChain]);
  useEffect(() => {
    if (userData) {
      const claimStatus = userData[0];
      const streak = userData[1];
      const totalPoints = userData[2];
      const lastCheckin = userData[3];
      const parent = userData[4];
      console.log("userData parent",parent);
      setTotalDayPoints(Number(userData[5]));
      setTotalNftPoints(Number(userData[6]));
      setClaim(claimStatus);
      setCurrentStreak(Number(streak));
      setPoints(Number(totalPoints));
      setParentAddress(parent);
      
      if (lastCheckin != 0 && !claimStatus) {
        const nextCheckinTime = Number(lastCheckin) + 86400;
        const currentTime = Math.floor(Date.now() / 1000);
        let remainingTime = nextCheckinTime - currentTime;
        if (remainingTime < 0) remainingTime = 0;
        setTimeLeft(secondsToTime(remainingTime));
      }
      
      setIsNewUser(Number(lastCheckin) === 0);
    }
  }, [userData]);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setTimeLeft(prev => {
        let totalSeconds = (parseInt(prev.hours) * 3600) + 
                          (parseInt(prev.minutes) * 60) + 
                          parseInt(prev.seconds);
        
        if (totalSeconds <= 0) {
          setClaim(true);
          clearInterval(timerInterval);
          return prev;
        }
        
        totalSeconds--;
        return secondsToTime(totalSeconds);
      });
    }, 1000);
  
    return () => clearInterval(timerInterval);
  }, [claim]);
  
  useEffect(() => {
    const setFirstNTrue = (n) => {
      setDaysChecked(prevArray => prevArray.map((_, index) => index < n));
    };
    setFirstNTrue(currentStreak);
  }, [currentStreak]);
  
  const handleTabChange = (newValue) => {
    if (newValue === 'nft') {
      window.location.href = 'https://home.fruitsweb3.xyz';
      return;
    }
    
    navigateToTab(newValue);
  };
  
  const handleClaim = async () => {
    if (!isConnected) {
      setWalletModalOpen(true);
      return;
    }
    /*const isOnBaseNetwork = await checkBaseNetwork();
    if (!isOnBaseNetwork) {
      return; 
    }*/

    if (chainId !== base.id) {
      if (switchChain) {
        switchChain({ chainId: base.id });
        toast.info("Switching to Base network...");
        return;
      } else {
        toast.error('Please switch to Base network');
        return;
      }
    }

    if (claim) {
      let finalReferral = '0x0000000000000000000000000000000000000000';
      
      if (isNewUser) {
        const urlParams = new URLSearchParams(window.location.search);
        const refFromUrl = urlParams.get('ref');
        
        if (refFromUrl && refFromUrl !== address && isAddress(refFromUrl)) {
          finalReferral = refFromUrl;
        }
      }
      
      setReferralAddress(finalReferral);
      
      if (checkIn) {
        console.log("checkIn",finalReferral);
        setConnectWalletString('Loading...');
        checkIn({
          address: contractAddress,
          abi: contractAbi,
          functionName: 'checkIn',
          args: [finalReferral],
          chainId: base.id,
        });
      }
    }
  };
  
  const navigateToTab = (tabValue) => {
    const path = tabToPathMap[tabValue];
    if (path) {
      const searchParams = new URLSearchParams(window.location.search);
      const searchString = searchParams.toString();
      
      const newUrl = searchString ? `${path}?${searchString}` : path;
      
      window.history.pushState({}, '', newUrl);
      setActiveTab(tabValue);
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Box
      sx={{
        minHeight: isMobile ? '100vh' : '100vh',
        background: activeTab === 'home' ? 'transparent' : BLACK,
        p: activeTab === 'home' ? 0 : { xs: 1, sm: 4, md: 6 },
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row', 
        justifyContent: isMobile ? 'flex-start' : 'center', 
        alignItems: 'center',
        position: 'relative',
        pb: isMobile ? '56px' : 0,
        pt: isMobile ? '56px !important' : 0,
        overflowY: activeTab === 'home' ? 'auto' : 'visible'
      }}
    >
      <DesktopMenu 
        activeTab={activeTab}
        handleTabChange={handleTabChange}
        isConnected={isConnected}
        address={address}
        disconnect={disconnect}
        setWalletModalOpen={setWalletModalOpen}
        toggleMenu={toggleMenu}
      />
      <SwitchNetworkModal
        open={switchNetworkModal.open}
        onClose={closeSwitchNetworkModal}
        currentNetwork={switchNetworkModal.currentNetwork}
        targetNetwork={switchNetworkModal.targetNetwork}
      />
      <AnimatePresence>
        {claimed && <FireworksEffect />}
      </AnimatePresence>

      {activeTab === 'home' || activeTab === 'home2' || activeTab === 'blog' ? (
        <HomeContent 
          menuOpen={menuOpen}
          toggleMenu={toggleMenu}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          blogSlug={blogSlug} 
          setBlogSlug={setBlogSlug}
        />
      ) : (
        <GlowCard
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, type: 'spring' }}
          sx={{
            width: { xs: '90%', sm: '80%', md: 600 },
            mt: 4
          }}
        >
          <Stack spacing={4} sx={{ position: 'relative', zIndex: 1 }}>
            {activeTab === 'daily' && (
              <DailyContent 
                points={points}
                daysChecked={daysChecked}
                handleClaim={handleClaim}
                account={address}
                claim={claim}
                ConnectWalletString={ConnectWalletString}
                claimed={claimed}
                connectWallet={() => setWalletModalOpen(true)}
                timeLeft={timeLeft}
              />
            )}
            {activeTab === 'nfts' && (
              <NftContent 
                hasNft={hasNft}
                handleNft={handleNft}
                account={address}
                isMinting={isMinting}
                nftImage={nftImage}
                mintClickCount={mintClickCount}
                totalNfts={totalNfts}
                maxNfts={maxNfts}
              />
            )}
            {activeTab === 'referral' && <ReferralContent 
              referralLink={referralLink}
              referralsList={referralsList}
              parentAddress={parentAddress}
              isNewUser={isNewUser}
            />}
            {activeTab === 'tasks' && <LearnMintSection onConnect={() => setWalletModalOpen(true)} />}
            {activeTab === 'more' &&  <MoreContent 
              points={points}
              totalDayPoints={totalDayPoints}
              totalNftPoints={totalNftPoints}
            />}
          </Stack>
        </GlowCard>
      )}

      <MobileBottomNav 
        activeTab={activeTab} 
        handleTabChange={handleTabChange}
        toggleMenu={toggleMenu}
      />
      <WalletModal open={walletModalOpen} onClose={() => setWalletModalOpen(false)} />
      <ToastContainer />
    </Box>
  );
};

const App = () => {
  return (
    <ThemeProvider theme={customTheme}>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <DailyCheckIn />
      </QueryClientProvider>
    </WagmiProvider>
    </ThemeProvider>
  );
};

export default App;